import { List, Map } from 'immutable';

import { EBAY, ETSY, FAIRE, SHOPIFY } from './channels';
import { ATTRIBUTE } from './attributes';
import { CURRENCY } from './product';
import { EMPTY } from '.';
import { FORM } from './forms';

export const ADD = 'add';

export const FIND = 'find';

export const REPLACE = 'replace';

export const DELETE = 'delete';

export const FILTER = {
  [EBAY]: {
    TAXONOMY_IDS: 'category_ids',
    TITLE: 'title',
  },
  [ETSY]: {
    IS_DIGITAL: 'is_digital',
    TAXONOMY_IDS: 'taxonomy_ids',
    TITLE: 'title',
  },
  [FAIRE]: {
    TITLE: 'title',
  },
  [SHOPIFY]: {
    TITLE: 'title',
  },
};

export const MENU_SECTION = {
  INVENTORY: 'inventory',
  LISTINGS: 'listings',
  MEDIA: 'media',
  SEO: 'seo',
  SHIPPING: 'shipping',
  TAXONOMY: 'taxonomy',
};

export const MENU_SECTION_NAME = {
  [EBAY]: {
    [MENU_SECTION.INVENTORY]: 'Inventory',
    [MENU_SECTION.LISTINGS]: 'Listings',
    [MENU_SECTION.MEDIA]: 'Media',
    [MENU_SECTION.SHIPPING]: 'Shipping',
    [MENU_SECTION.TAXONOMY]: 'Item specifics',
  },
  [ETSY]: {
    [MENU_SECTION.INVENTORY]: 'Inventory',
    [MENU_SECTION.LISTINGS]: 'Listings',
    [MENU_SECTION.MEDIA]: 'Media',
    [MENU_SECTION.SHIPPING]: 'Shipping',
    [MENU_SECTION.TAXONOMY]: 'Optional',
  },
  [FAIRE]: {
    [MENU_SECTION.INVENTORY]: 'Inventory',
    [MENU_SECTION.LISTINGS]: 'Listings',
    [MENU_SECTION.MEDIA]: 'Media',
    [MENU_SECTION.SHIPPING]: 'Shipping',
  },
  [SHOPIFY]: {
    [MENU_SECTION.INVENTORY]: 'Inventory',
    [MENU_SECTION.LISTINGS]: 'Listings',
    [MENU_SECTION.MEDIA]: 'Media',
    [MENU_SECTION.SEO]: 'SEO listing',
    [MENU_SECTION.SHIPPING]: 'Shipping',
  },
};

export const MENU_ITEM = {
  ABOUT: 'About',
  AVAILABILITY: 'Availability',
  BARCODE: 'Barcode',
  BODY_HTML: 'Description',
  CAP: 'Compare at price',
  CATEGORY: 'Category',
  COLLECTIONS: 'Collections',
  CONDITION: 'Condition',
  COUNTRY_CODE: 'Country or Region',
  CPI: 'Cost',
  DESCRIPTION: 'Description',
  FILES: 'Digital files',
  GTIN: 'GTIN',
  HS_CODE: 'HS Code',
  ITEM_CATEGORY: 'Item category',
  ITEM_LOCATION: 'Item location',
  ITEM_SIZE: 'Item size',
  ITEM_WEIGHT: 'Item weight',
  MATERIALS: 'Materials',
  META_DESCRIPTION: 'Meta description',
  PAGE_TITLE: 'Page title',
  PAYMENT_POLICY: 'Payment policy',
  PERSONALIZATION: 'Personalization',
  PHOTOS: 'Photos',
  PRICE: 'Price',
  PROCESSING_PROFILE: 'Processing profile',
  PRODUCTION_PARTNER: 'Production partner',
  PRODUCT_TYPE: 'Product type',
  QUANTITY: 'Quantity',
  RETURN_POLICY: 'Return policy',
  SECTION: 'Section',
  SELLING_METHOD: 'Selling method',
  SHIPPING_POLICY: 'Shipping policy',
  SHIPPING_PROFILE: 'Shipping profile',
  STORE_CATEGORY: 'Store category',
  SKU: 'SKU',
  TAGS: 'Tags',
  TARIFF_CODE: 'Tariff code',
  TAXONOMY: 'taxonomy',
  TITLE: 'Title',
  VARIATIONS: 'Variations',
  VENDOR: 'Vendor',
  VIDEOS: 'Videos',
  WEIGHT: 'Weight',
};

export const ATTRIBUTE_TO_MENU_ITEM_MAP = {
  [ATTRIBUTE.BARCODE]: MENU_ITEM.BARCODE,
  [ATTRIBUTE.CAP]: MENU_ITEM.CAP,
  [ATTRIBUTE.CASE_SIZE]: MENU_ITEM.SELLING_METHOD,
  [ATTRIBUTE.CATEGORY]: MENU_ITEM.CATEGORY,
  [ATTRIBUTE.CHAR_COUNT_MAX]: MENU_ITEM.PERSONALIZATION,
  [ATTRIBUTE.COLLECTIONS]: MENU_ITEM.COLLECTIONS,
  [ATTRIBUTE.CONDITION]: MENU_ITEM.CONDITION,
  [ATTRIBUTE.COUNTRY]: MENU_ITEM.ITEM_LOCATION,
  [ATTRIBUTE.COUNTRY_CODE]: MENU_ITEM.COUNTRY_CODE,
  [ATTRIBUTE.CPI]: MENU_ITEM.CPI,
  [ATTRIBUTE.DEPTH]: MENU_ITEM.ITEM_SIZE,
  [ATTRIBUTE.FILES]: MENU_ITEM.FILES,
  [ATTRIBUTE.HEIGHT]: MENU_ITEM.ITEM_SIZE,
  [ATTRIBUTE.HS_CODE]: MENU_ITEM.HS_CODE,
  [ATTRIBUTE.INSTRUCTIONS]: MENU_ITEM.PERSONALIZATION,
  [ATTRIBUTE.IS_SUPPLY]: MENU_ITEM.ABOUT,
  [ATTRIBUTE.ITEM_CATEGORY]: MENU_ITEM.ITEM_CATEGORY,
  [ATTRIBUTE.ITEM_SPECIFICS]: MENU_ITEM.TAXONOMY,
  [ATTRIBUTE.LENGTH]: MENU_ITEM.ITEM_SIZE,
  [ATTRIBUTE.LOCATION]: MENU_ITEM.ITEM_LOCATION,
  [ATTRIBUTE.MATERIALS]: MENU_ITEM.MATERIALS,
  [ATTRIBUTE.META_DESCRIPTION]: MENU_ITEM.META_DESCRIPTION,
  [ATTRIBUTE.MINIMUM_ORDER_QUANTITY]: MENU_ITEM.SELLING_METHOD,
  [ATTRIBUTE.PAGE_TITLE]: MENU_ITEM.PAGE_TITLE,
  [ATTRIBUTE.PAYMENT_POLICY]: MENU_ITEM.PAYMENT_POLICY,
  [ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY]: MENU_ITEM.SELLING_METHOD,
  [ATTRIBUTE.PERSONALIZATION]: MENU_ITEM.PERSONALIZATION,
  [ATTRIBUTE.PHOTOS]: MENU_ITEM.PHOTOS,
  [ATTRIBUTE.POSTAL_CODE]: MENU_ITEM.ITEM_LOCATION,
  [ATTRIBUTE.PRICE]: MENU_ITEM.PRICE,
  [ATTRIBUTE.PROCESSING_PROFILE]: MENU_ITEM.PROCESSING_PROFILE,
  [ATTRIBUTE.PRODUCTION_PARTNERS]: MENU_ITEM.PRODUCTION_PARTNER,
  [ATTRIBUTE.PRODUCT_TYPE]: MENU_ITEM.PRODUCT_TYPE,
  [ATTRIBUTE.PROFILE_ID]: MENU_ITEM.SHIPPING_PROFILE,
  [ATTRIBUTE.QUANTITY]: MENU_ITEM.QUANTITY,
  [ATTRIBUTE.RETAIL_PRICE]: MENU_ITEM.PRICE,
  [ATTRIBUTE.RETURN_POLICY]: MENU_ITEM.RETURN_POLICY,
  [ATTRIBUTE.SECTION]: MENU_ITEM.SECTION,
  [ATTRIBUTE.SELLING_METHOD]: MENU_ITEM.SELLING_METHOD,
  [ATTRIBUTE.SHIPPING_POLICY]: MENU_ITEM.SHIPPING_POLICY,
  [ATTRIBUTE.SKU]: MENU_ITEM.SKU,
  [ATTRIBUTE.STORE_CATEGORY]: MENU_ITEM.STORE_CATEGORY,
  [ATTRIBUTE.TAGS]: MENU_ITEM.TAGS,
  [ATTRIBUTE.TAXONOMY_ATTRIBUTES]: MENU_ITEM.TAXONOMY,
  [ATTRIBUTE.TARIFF_CODE]: MENU_ITEM.TARIFF_CODE,
  [ATTRIBUTE.TITLE]: MENU_ITEM.TITLE,
  [ATTRIBUTE.VARIATIONS]: MENU_ITEM.VARIATIONS,
  [ATTRIBUTE.VENDOR]: MENU_ITEM.VENDOR,
  [ATTRIBUTE.WEIGHT]: MENU_ITEM.WEIGHT,
  [ATTRIBUTE.WEIGHT_MAJOR]: MENU_ITEM.ITEM_WEIGHT,
  [ATTRIBUTE.WEIGHT_MINOR]: MENU_ITEM.ITEM_WEIGHT,
  [ATTRIBUTE.WHEN_MADE]: MENU_ITEM.ABOUT,
  [ATTRIBUTE.WHO_MADE]: MENU_ITEM.ABOUT,
  [ATTRIBUTE.WHOLESALE_PRICE]: MENU_ITEM.PRICE,
  [ATTRIBUTE.WIDTH]: MENU_ITEM.ITEM_SIZE,
};

export const FORM_TO_MENU_ITEM_MAP = {
  [EBAY]: {
    [FORM.DESCRIPTION]: MENU_ITEM.DESCRIPTION,
    [FORM.DETAILS]: MENU_ITEM.ITEM_CATEGORY,
    [FORM.INVENTORY]: MENU_ITEM.QUANTITY,
    [FORM.PHOTOS]: MENU_ITEM.PHOTOS,
    [FORM.VIDEOS]: MENU_ITEM.VIDEOS,
    [FORM.PRICING]: MENU_ITEM.PRICE,
    [FORM.SHIPPING]: MENU_ITEM.SHIPPING_POLICY,
    [FORM.TITLE]: MENU_ITEM.TITLE,
    [FORM.VARIATIONS]: MENU_ITEM.VARIATIONS,
  },
  [ETSY]: {
    [FORM.DESCRIPTION]: MENU_ITEM.DESCRIPTION,
    [FORM.DETAILS]: MENU_ITEM.CATEGORY,
    [FORM.FILES]: MENU_ITEM.FILES,
    [FORM.INVENTORY]: MENU_ITEM.QUANTITY,
    [FORM.PERSONALIZATION]: MENU_ITEM.PERSONALIZATION,
    [FORM.PHOTOS]: MENU_ITEM.PHOTOS,
    [FORM.VIDEOS]: MENU_ITEM.VIDEOS,
    [FORM.PRICING]: MENU_ITEM.PRICE,
    [FORM.SHIPPING]: MENU_ITEM.PROCESSING_PROFILE,
    [FORM.TAGS]: MENU_ITEM.TAGS,
    [FORM.TITLE]: MENU_ITEM.TITLE,
    [FORM.VARIATIONS]: MENU_ITEM.VARIATIONS,
  },
  [FAIRE]: {
    [FORM.DESCRIPTION]: MENU_ITEM.DESCRIPTION,
    [FORM.DETAILS]: MENU_ITEM.ITEM_CATEGORY,
    [FORM.INVENTORY]: MENU_ITEM.QUANTITY,
    [FORM.PHOTOS]: MENU_ITEM.PHOTOS,
    [FORM.PRICING]: MENU_ITEM.PRICE,
    [FORM.SHIPPING]: MENU_ITEM.SELLING_METHOD,
    [FORM.TITLE]: MENU_ITEM.TITLE,
    [FORM.VARIATIONS]: MENU_ITEM.VARIATIONS,
  },
  [SHOPIFY]: {
    [FORM.DESCRIPTION]: MENU_ITEM.BODY_HTML,
    [FORM.DETAILS]: MENU_ITEM.PRODUCT_TYPE,
    [FORM.INVENTORY]: MENU_ITEM.QUANTITY,
    [FORM.PHOTOS]: MENU_ITEM.PHOTOS,
    [FORM.VIDEOS]: MENU_ITEM.VIDEOS,
    [FORM.PRICING]: MENU_ITEM.PRICE,
    [FORM.SEO]: MENU_ITEM.PAGE_TITLE,
    [FORM.SHIPPING]: MENU_ITEM.WEIGHT,
    [FORM.TAGS]: MENU_ITEM.TAGS,
    [FORM.TITLE]: MENU_ITEM.TITLE,
    [FORM.VARIATIONS]: MENU_ITEM.VARIATIONS,
  },
};

export const MENU_SECTIONS = {
  [EBAY]: List([
    MENU_SECTION.MEDIA,
    MENU_SECTION.LISTINGS,
    MENU_SECTION.TAXONOMY,
    MENU_SECTION.INVENTORY,
    MENU_SECTION.SHIPPING,
  ]),
  [ETSY]: List([
    MENU_SECTION.MEDIA,
    MENU_SECTION.LISTINGS,
    MENU_SECTION.TAXONOMY,
    MENU_SECTION.INVENTORY,
    MENU_SECTION.SHIPPING,
  ]),
  [FAIRE]: List([
    MENU_SECTION.MEDIA,
    MENU_SECTION.LISTINGS,
    MENU_SECTION.INVENTORY,
    MENU_SECTION.SHIPPING,
  ]),
  [SHOPIFY]: List([
    MENU_SECTION.MEDIA,
    MENU_SECTION.LISTINGS,
    MENU_SECTION.INVENTORY,
    MENU_SECTION.SHIPPING,
    MENU_SECTION.SEO,
  ]),
};

export const MENU_SECTION_ITEMS = {
  [EBAY]: Map({
    [MENU_SECTION.INVENTORY]: List([
      MENU_ITEM.VARIATIONS,
      MENU_ITEM.PRICE,
      MENU_ITEM.QUANTITY,
      MENU_ITEM.SKU,
    ]),
    [MENU_SECTION.TAXONOMY]: EMPTY.LIST,
    [MENU_SECTION.LISTINGS]: List([
      MENU_ITEM.TITLE,
      MENU_ITEM.DESCRIPTION,
      MENU_ITEM.ITEM_CATEGORY,
      MENU_ITEM.CONDITION,
    ]),
    [MENU_SECTION.MEDIA]: List([
      MENU_ITEM.PHOTOS,
      MENU_ITEM.VIDEOS,
    ]),
    [MENU_SECTION.SHIPPING]: List([
      MENU_ITEM.SHIPPING_POLICY,
      MENU_ITEM.ITEM_WEIGHT,
      MENU_ITEM.ITEM_SIZE,
      MENU_ITEM.ITEM_LOCATION,
      MENU_ITEM.RETURN_POLICY,
    ]),
  }),
  [ETSY]: Map({
    [MENU_SECTION.INVENTORY]: List([
      MENU_ITEM.VARIATIONS,
      MENU_ITEM.PRICE,
      MENU_ITEM.QUANTITY,
      MENU_ITEM.SKU,
    ]),
    [MENU_SECTION.LISTINGS]: List([
      MENU_ITEM.TITLE,
      MENU_ITEM.DESCRIPTION,
      MENU_ITEM.TAGS,
      MENU_ITEM.MATERIALS,
      MENU_ITEM.ABOUT,
      MENU_ITEM.PRODUCTION_PARTNER,
      MENU_ITEM.CATEGORY,
      MENU_ITEM.SECTION,
      MENU_ITEM.PERSONALIZATION,
    ]),
    [MENU_SECTION.MEDIA]: List([
      MENU_ITEM.PHOTOS,
      MENU_ITEM.VIDEOS,
    ]),
    [MENU_SECTION.SHIPPING]: List([
      MENU_ITEM.PROCESSING_PROFILE,
      MENU_ITEM.SHIPPING_PROFILE,
      MENU_ITEM.ITEM_WEIGHT,
      MENU_ITEM.ITEM_SIZE,
      MENU_ITEM.RETURN_POLICY,
    ]),
    [MENU_SECTION.TAXONOMY]: EMPTY.LIST,
  }),
  [FAIRE]: Map({
    [MENU_SECTION.MEDIA]: List([
      MENU_ITEM.PHOTOS,
    ]),
    [MENU_SECTION.LISTINGS]: List([
      MENU_ITEM.TITLE,
      MENU_ITEM.DESCRIPTION,
      MENU_ITEM.CATEGORY,
    ]),
    [MENU_SECTION.INVENTORY]: List([
      MENU_ITEM.VARIATIONS,
      MENU_ITEM.PRICE,
      MENU_ITEM.QUANTITY,
      MENU_ITEM.SKU,
      MENU_ITEM.GTIN,
      MENU_ITEM.AVAILABILITY,
    ]),
    [MENU_SECTION.SHIPPING]: List([
      MENU_ITEM.SELLING_METHOD,
      MENU_ITEM.TARIFF_CODE,
      MENU_ITEM.ITEM_WEIGHT,
      MENU_ITEM.ITEM_SIZE,
    ]),
  }),
  [SHOPIFY]: Map({
    [MENU_SECTION.INVENTORY]: List([
      MENU_ITEM.VARIATIONS,
      MENU_ITEM.PRICE,
      MENU_ITEM.CAP,
      MENU_ITEM.CPI,
      MENU_ITEM.QUANTITY,
      MENU_ITEM.SKU,
      MENU_ITEM.BARCODE,
    ]),
    [MENU_SECTION.LISTINGS]: List([
      MENU_ITEM.TITLE,
      MENU_ITEM.BODY_HTML,
      MENU_ITEM.TAGS,
      MENU_ITEM.CATEGORY,
      MENU_ITEM.PRODUCT_TYPE,
      MENU_ITEM.VENDOR,
      MENU_ITEM.COLLECTIONS,
    ]),
    [MENU_SECTION.MEDIA]: List([
      MENU_ITEM.PHOTOS,
      MENU_ITEM.VIDEOS,
    ]),
    [MENU_SECTION.SEO]: List([
      MENU_ITEM.PAGE_TITLE,
      MENU_ITEM.META_DESCRIPTION,
    ]),
    [MENU_SECTION.SHIPPING]: List([
      MENU_ITEM.WEIGHT,
      MENU_ITEM.COUNTRY_CODE,
      MENU_ITEM.HS_CODE,
    ]),
  }),
};

export const MENU_ITEM_BADGE = {
};

export const MENU_SECTION_BADGE = {
};

export const OPERATIONS = {
  [EBAY]: {
    AI: 'ai',
    CONDITION_DESCRIPTION: {
      ADD_AFTER: 'condition_description.addAfter',
      ADD_BEFORE: 'condition_description.addBefore',
      DELETE: 'condition_description.delete',
      FIND_AND_REPLACE: 'condition_description.findAndReplace',
      SET: 'condition_description.set',
    },
    CONDITION_ID: 'condition_id.set',
    COUNTRY: 'country.set',
    DEPTH: {
      DECREASE_BY: 'shipping_package_depth.decreaseBy',
      INCREASE_BY: 'shipping_package_depth.increaseBy',
      SET: 'shipping_package_depth.set',
    },
    DESCRIPTION: {
      ADD_AFTER: 'description.addAfter',
      ADD_BEFORE: 'description.addBefore',
      AI_GENERATED: 'description.aiGenerated',
      DELETE: 'description.delete',
      FIND_AND_REPLACE: 'description.findAndReplace',
      SET: 'description.set',
    },
    IRREGULAR: 'shipping_package_irregular.set',
    ITEM_CATEGORY: 'category_id.set',
    ITEM_SPECIFICS: {
      SET: 'item_specifics.set',
      UPDATE: 'item_specifics.update',
    },
    KEYWORDS: {
      SET: 'keywords.set',
    },
    LENGTH: {
      DECREASE_BY: 'shipping_package_length.decreaseBy',
      INCREASE_BY: 'shipping_package_length.increaseBy',
      SET: 'shipping_package_length.set',
    },
    LOCATION: 'location.set',
    PAYMENT_POLICY: 'payment_policy_id.set',
    PHOTOS: {
      ADD: 'photos.add',
      CHANGE_TO: 'photos.changeTo',
      DELETE: 'photos.delete',
      REPLACE: 'photos.replace',
      SWAP: 'photos.swap',
      UPDATE: 'photos.update',
    },
    POSTAL_CODE: 'postal_code.set',
    PRICE: {
      CHANGE_TO: 'price.set',
      DECREASE_BY: 'price.decreaseBy',
      INCREASE_BY: 'price.increaseBy',
    },
    PRODUCT_DETAILS: {
      SET: 'product_listing_details.set',
      UPDATE: 'product_listing_details.update',
    },
    QUANTITY: {
      CHANGE_TO: 'quantity.set',
      DECREASE_BY: 'quantity.decreaseBy',
      INCREASE_BY: 'quantity.increaseBy',
    },
    RETURN_POLICY: 'return_policy_id.set',
    SKU: {
      ADD_AFTER: 'sku.addAfter',
      ADD_BEFORE: 'sku.addBefore',
      CHANGE_TO: 'sku.set',
      DELETE: 'sku.delete',
      FIND_AND_REPLACE: 'sku.findAndReplace',
    },
    SIZE: {
      SET: 'size.set',
      DECREASE_BY: 'size.decreaseBy',
      INCREASE_BY: 'size.increaseBy',
    },
    SHIPPING_POLICY: 'shipping_policy_id.set',
    STATUS: 'status.set',
    STORE_CATEGORY: 'custom_category_id.set',
    TITLE: {
      ADD_AFTER: 'title.addAfter',
      ADD_BEFORE: 'title.addBefore',
      AI_GENERATED: 'title.aiGenerated',
      DELETE: 'title.delete',
      FIND_AND_REPLACE: 'title.findAndReplace',
      SET: 'title.set',
    },
    VARIATIONS: 'variationsInventory.changeTo',
    VIDEOS: {
      ADD: 'videos.add',
      CHANGE_TO: 'videos.changeTo',
      DELETE: 'videos.delete',
      REPLACE: 'videos.replace',
    },
    WEIGHT: {
      SET: 'weight.set',
      INCREASE_BY: 'weight.increaseBy',
      DECREASE_BY: 'weight.decreaseBy',
    },
    WEIGHT_MAJOR: {
      DECREASE_BY: 'shipping_package_major_weight.decreaseBy',
      INCREASE_BY: 'shipping_package_major_weight.increaseBy',
      SET: 'shipping_package_major_weight.set',
    },
    WEIGHT_MINOR: {
      DECREASE_BY: 'shipping_package_minor_weight.decreaseBy',
      INCREASE_BY: 'shipping_package_minor_weight.increaseBy',
      SET: 'shipping_package_minor_weight.set',
    },
    WIDTH: {
      DECREASE_BY: 'shipping_package_width.decreaseBy',
      INCREASE_BY: 'shipping_package_width.increaseBy',
      SET: 'shipping_package_width.set',
    },
  },
  [ETSY]: {
    AI: 'ai',
    CATEGORY: 'taxonomy.set',
    DESCRIPTION: {
      ADD_AFTER: 'description.addAfter',
      ADD_BEFORE: 'description.addBefore',
      AI_GENERATED: 'description.aiGenerated',
      DELETE: 'description.delete',
      FIND_AND_REPLACE: 'description.findAndReplace',
      SET: 'description.set',
    },
    FILES: {
      ADD: 'files.add',
      CHANGE_TO: 'files.changeTo',
      DELETE: 'files.delete',
      REPLACE: 'files.replace',
      SWAP: 'files.swap',
    },
    HEIGHT: {
      SET: 'itemHeight.set',
      INCREASE_BY: 'itemHeight.increaseBy',
      DECREASE_BY: 'itemHeight.decreaseBy',
    },
    IS_SUPPLY: 'is_supply.set',
    LENGTH: {
      SET: 'itemLength.set',
      DECREASE_BY: 'itemLength.decreaseBy',
      INCREASE_BY: 'itemLength.increaseBy',
    },
    MATERIALS: {
      ADD: 'materials.add',
      CHANGE_TO: 'materials.changeTo',
      DELETE: 'materials.delete',
    },
    PERSONALIZATION: {
      IS_PERSONALIZABLE_SET: 'isPersonalizable.set',
      IS_REQUIRED_SET: 'personalizationIsRequired.set',
      CHAR_COUNT_MAX_SET: 'personalizationCharCountMax.set',
      INSTRUCTIONS_ADD_BEFORE: 'personalizationInstructions.addBefore',
      INSTRUCTIONS_ADD_AFTER: 'personalizationInstructions.addAfter',
      INSTRUCTIONS_FIND_AND_REPLACE: 'personalizationInstructions.findAndReplace',
      INSTRUCTIONS_DELETE: 'personalizationInstructions.delete',
      INSTRUCTIONS_SET: 'personalizationInstructions.set',
    },
    PHOTOS: {
      ALT_TEXT: 'photos.altText',
      ALT_TEXT_AI_GENERATED: 'photos.altText.aiGenerated',
      ADD: 'photos.add',
      CHANGE_TO: 'photos.changeTo',
      DELETE: 'photos.delete',
      REPLACE: 'photos.replace',
      SWAP: 'photos.swap',
      UPDATE: 'photos.update',
    },
    PRICE: {
      INCREASE_BY: 'priceInventory.increaseBy',
      DECREASE_BY: 'priceInventory.decreaseBy',
      CHANGE_TO: 'priceInventory.changeTo',
    },
    PROCESSING_PROFILE: 'readinessStateIdInventory.changeTo',
    PRODUCTION_PARTNERS: 'productionPartners.set',
    QUANTITY: {
      CHANGE_TO: 'quantityInventory.changeTo',
      DECREASE_BY: 'quantityInventory.decreaseBy',
      INCREASE_BY: 'quantityInventory.increaseBy',
    },
    RETURN_POLICY: 'return_policy_id.set',
    SECTION: 'section.set',
    SHIPPING_PROFILE: 'shipping_template_id.set',
    SIZE: {
      SET: 'itemSize.set',
      INCREASE_BY: 'itemSize.increaseBy',
      DECREASE_BY: 'itemSize.decreaseBy',
    },
    SKU: {
      DELETE: 'skuInventory.delete',
      CHANGE_TO: 'skuInventory.changeTo',
      ADD_AFTER: 'skuInventory.addAfter',
      ADD_BEFORE: 'skuInventory.addBefore',
      FIND_AND_REPLACE: 'skuInventory.findAndReplace',
    },
    STATUS: 'status.set',
    TAGS: {
      ADD: 'tags.add',
      AI_GENERATED: 'tags.aiGenerated',
      CHANGE_TO: 'tags.changeTo',
      DELETE: 'tags.delete',
    },
    TAXONOMY_ATTRIBUTES: 'attributes.set',
    TITLE: {
      ADD_AFTER: 'title.addAfter',
      ADD_BEFORE: 'title.addBefore',
      AI_GENERATED: 'title.aiGenerated',
      DELETE: 'title.delete',
      FIND_AND_REPLACE: 'title.findAndReplace',
      SET: 'title.set',
    },
    VARIATIONS: 'variationsInventory.changeTo',
    VIDEOS: {
      ADD: 'videos.add',
      CHANGE_TO: 'videos.changeTo',
      DELETE: 'videos.delete',
      REPLACE: 'videos.replace',
    },
    WEIGHT: {
      SET: 'itemWeight.set',
      DECREASE_BY: 'itemWeight.decreaseBy',
      INCREASE_BY: 'itemWeight.increaseBy',
    },
    WHEN_MADE: 'when_made.set',
    WHO_MADE: 'who_made.set',
    WIDTH: {
      SET: 'itemWidth.set',
      DECREASE_BY: 'itemWidth.decreaseBy',
      INCREASE_BY: 'itemWidth.increaseBy',
    },
  },
  [FAIRE]: {
    AI: 'ai',
    CASE_SIZE: {
      DECREASE_BY: 'unit_multiplier.decreaseBy',
      INCREASE_BY: 'unit_multiplier.increaseBy',
      SET: 'unit_multiplier.set',
    },
    CATEGORY: 'category_id.set',
    CONTINUE_SELLING: {
      SET: 'allow_sales_when_out_of_stock.set',
    },
    DEADLINE_DATE: {
      SET: 'preorder_details_stop_selling_at.set',
    },
    DESCRIPTION: {
      ADD_AFTER: 'description.addAfter',
      ADD_BEFORE: 'description.addBefore',
      AI_GENERATED: 'description.aiGenerated',
      DELETE: 'description.delete',
      FIND_AND_REPLACE: 'description.findAndReplace',
      SET: 'description.set',
    },
    DISTANCE_UNIT: 'measurements_distance_unit.set',
    END_DATE: {
      SET: 'preorder_details_expected_ship_window_end_date.set',
    },
    GTIN: {
      DELETE: 'gtin.delete',
      CHANGE_TO: 'gtin.changeTo',
      ADD_AFTER: 'gtin.addAfter',
      ADD_BEFORE: 'gtin.addBefore',
      FIND_AND_REPLACE: 'gtin.findAndReplace',
    },
    HEIGHT: {
      DECREASE_BY: 'measurements_height.decreaseBy',
      INCREASE_BY: 'measurements_height.increaseBy',
      SET: 'measurements_height.set',
    },
    KEEP_ACTIVE: {
      SET: 'preorder_details_keep_active_past_order_by_date.set',
    },
    LENGTH: {
      DECREASE_BY: 'measurements_length.decreaseBy',
      INCREASE_BY: 'measurements_length.increaseBy',
      SET: 'measurements_length.set',
    },
    MASS_UNIT: 'measurements_mass_unit.set',
    MINIMUM_ORDER_QUANTITY: {
      DECREASE_BY: 'minimum_order_quantity.decreaseBy',
      INCREASE_BY: 'minimum_order_quantity.increaseBy',
      SET: 'minimum_order_quantity.set',
    },
    PER_STYLE_MINIMUM_ORDER_QUANTITY: {
      DECREASE_BY: 'per_style_minimum_order_quantity.decreaseBy',
      INCREASE_BY: 'per_style_minimum_order_quantity.increaseBy',
      SET: 'per_style_minimum_order_quantity.set',
    },
    PHOTOS: {
      ADD: 'photos.add',
      CHANGE_TO: 'photos.changeTo',
      DELETE: 'photos.delete',
      REPLACE: 'photos.replace',
      SWAP: 'photos.swap',
      UPDATE: 'photos.update',
    },
    PREORDER: {
      SET: 'preorderable.set',
    },
    PRICES: {
      DECREASE_BY: 'prices.decreaseBy',
      INCREASE_BY: 'prices.increaseBy',
      SET: 'prices.set',
    },
    QUANTITY: {
      CHANGE_TO: 'available_quantity.changeTo',
      DECREASE_BY: 'available_quantity.decreaseBy',
      INCREASE_BY: 'available_quantity.increaseBy',
    },
    RESTOCK_DATE: {
      SET: 'backordered_until.set',
    },
    SCHEDULED_AT: 'scheduled_at.set',
    SKU: {
      DELETE: 'sku.delete',
      CHANGE_TO: 'sku.changeTo',
      ADD_AFTER: 'sku.addAfter',
      ADD_BEFORE: 'sku.addBefore',
      FIND_AND_REPLACE: 'sku.findAndReplace',
    },
    SIZE: {
      SET: 'size.set',
      INCREASE_BY: 'size.increaseBy',
      DECREASE_BY: 'size.decreaseBy',
    },
    START_DATE: {
      SET: 'preorder_details_expected_ship_date.set',
    },
    STATUS: 'status.set',
    TARIFF_CODE: {
      SET: 'tariff_code.set',
    },
    TITLE: {
      ADD_AFTER: 'title.addAfter',
      ADD_BEFORE: 'title.addBefore',
      AI_GENERATED: 'title.aiGenerated',
      DELETE: 'title.delete',
      FIND_AND_REPLACE: 'title.findAndReplace',
      SET: 'title.set',
    },
    VARIATIONS: 'variationsInventory.changeTo',
    WEIGHT: {
      DECREASE_BY: 'measurements_weight.decreaseBy',
      INCREASE_BY: 'measurements_weight.increaseBy',
      SET: 'measurements_weight.set',
    },
    WIDTH: {
      DECREASE_BY: 'measurements_width.decreaseBy',
      INCREASE_BY: 'measurements_width.increaseBy',
      SET: 'measurements_width.set',
    },
  },
  [SHOPIFY]: {
    AI: 'ai',
    BARCODE: {
      DELETE: 'barcodeInventory.delete',
      CHANGE_TO: 'barcodeInventory.changeTo',
      ADD_AFTER: 'barcodeInventory.addAfter',
      ADD_BEFORE: 'barcodeInventory.addBefore',
      INLINE_EDIT: 'barcodeInventory.inlineedit',
      FIND_AND_REPLACE: 'barcodeInventory.findAndReplace',
    },
    CAP: {
      CHANGE_TO: 'comapreAtPriceInventory.changeTo',
      INLINE_EDIT: 'comapreAtPriceInventory.inlineedit',
      INCREASE_BY: 'comapreAtPriceInventory.increaseBy',
      DECREASE_BY: 'comapreAtPriceInventory.decreaseBy',
      COPY_FROM_PRICE: 'comapreAtPriceInventory.copyFromPrice',
    },
    CATEGORY: 'category.set',
    CHARGE_TAX: {
      SET: 'taxable.set',
      INLINE_EDIT: 'taxable.inlineedit',
    },
    COLLECTIONS: 'collection_ids.set',
    CONTINUE_SELLING: {
      SET: 'inventoryPolicy.set',
      INLINE_EDIT: 'inventoryPolicy.inlineedit',
    },
    COUNTRY_CODE: {
      SET: 'countryCode.set',
      INLINE_EDIT: 'countryCode.inlineedit',
    },
    CPI: {
      CHANGE_TO: 'costInventory.changeTo',
      INLINE_EDIT: 'costInventory.inlineedit',
      INCREASE_BY: 'costInventory.increaseBy',
      DECREASE_BY: 'costInventory.decreaseBy',
    },
    DESCRIPTION: {
      ADD_AFTER: 'body_html.addAfter',
      ADD_BEFORE: 'body_html.addBefore',
      AI_GENERATED: 'body_html.aiGenerated',
      DELETE: 'body_html.delete',
      FIND_AND_REPLACE: 'body_html.findAndReplace',
      SET: 'body_html.set',
    },
    HS_CODE: {
      SET: 'hsCode.set',
      INLINE_EDIT: 'hsCode.inlineedit',
    },
    INVENTORY_INLINE_EDIT: 'variations.inlineEdit',
    KEYWORDS: {
      SET: 'keywords.set',
    },
    META_DESCRIPTION: {
      ADD_AFTER: 'seoDescription.addAfter',
      ADD_BEFORE: 'seoDescription.addBefore',
      AI_GENERATED: 'seoDescription.aiGenerated',
      DELETE: 'seoDescription.delete',
      FIND_AND_REPLACE: 'seoDescription.findAndReplace',
      SET: 'seoDescription.set',
    },
    PAGE_TITLE: {
      ADD_AFTER: 'seoTitle.addAfter',
      ADD_BEFORE: 'seoTitle.addBefore',
      AI_GENERATED: 'seoTitle.aiGenerated',
      DELETE: 'seoTitle.delete',
      FIND_AND_REPLACE: 'seoTitle.findAndReplace',
      SET: 'seoTitle.set',
    },
    PHOTOS: {
      ALT_TEXT: 'photos.altText',
      ALT_TEXT_AI_GENERATED: 'photos.altText.aiGenerated',
      ADD: 'photos.add',
      CHANGE_TO: 'photos.changeTo',
      DELETE: 'photos.delete',
      REPLACE: 'photos.replace',
      SWAP: 'photos.swap',
      UPDATE: 'photos.update',
    },
    PHYSICAL: {
      SET: 'physical.set',
      INLINE_EDIT: 'physical.inlineedit',
    },
    PRICE: {
      CHANGE_TO: 'priceInventory.changeTo',
      INLINE_EDIT: 'priceInventory.inlineedit',
      INCREASE_BY: 'priceInventory.increaseBy',
      DECREASE_BY: 'priceInventory.decreaseBy',
      COPY_FROM_CAP: 'priceInventory.copyFromCap',
    },
    PRODUCT_TYPE: 'product_type.set',
    QUANTITY: {
      CHANGE_TO: 'quantityInventory.changeTo',
      INLINE_EDIT: 'quantityInventory.inlineedit',
      INCREASE_BY: 'quantityInventory.increaseBy',
      DECREASE_BY: 'quantityInventory.decreaseBy',
    },
    SKU: {
      DELETE: 'skuInventory.delete',
      CHANGE_TO: 'skuInventory.changeTo',
      ADD_AFTER: 'skuInventory.addAfter',
      ADD_BEFORE: 'skuInventory.addBefore',
      INLINE_EDIT: 'skuInventory.inlineedit',
      FIND_AND_REPLACE: 'skuInventory.findAndReplace',
    },
    STATUS: 'status.set',
    TAGS: {
      ADD: 'tags.add',
      AI_GENERATED: 'tags.aiGenerated',
      CHANGE_TO: 'tags.changeTo',
      DELETE: 'tags.delete',
    },
    TITLE: {
      ADD_AFTER: 'title.addAfter',
      ADD_BEFORE: 'title.addBefore',
      AI_GENERATED: 'title.aiGenerated',
      DELETE: 'title.delete',
      FIND_AND_REPLACE: 'title.findAndReplace',
      SET: 'title.set',
    },
    TRACK_QUANTITY: {
      SET: 'inventoryManagement.set',
    },
    VARIATIONS: 'variationsInventory.changeTo',
    VENDOR: 'vendor.set',
    VIDEOS: {
      ADD: 'videos.add',
      CHANGE_TO: 'videos.changeTo',
      DELETE: 'videos.delete',
      REPLACE: 'videos.replace',
    },
    WEIGHT: {
      CHANGE_TO: 'weight.changeTo',
      INLINE_EDIT: 'weight.inlineedit',
      INCREASE_BY: 'weight.increaseBy',
      DECREASE_BY: 'weight.decreaseBy',
    },
  },
};

export const MENU_ITEMS = {
  [EBAY]: Map({
    [MENU_ITEM.ITEM_CATEGORY]: Map({
      controls: 'ItemCategory',
      productRow: 'ItemCategory',
    }),
    [MENU_ITEM.CONDITION]: Map({
      controls: 'Condition',
      productRow: 'Condition',
      operations: List([
        // OPERATIONS[EBAY].CONDITION_DESCRIPTION.ADD_BEFORE,
        // OPERATIONS[EBAY].CONDITION_DESCRIPTION.ADD_AFTER,
        // OPERATIONS[EBAY].CONDITION_DESCRIPTION.FIND_AND_REPLACE,
        // OPERATIONS[EBAY].CONDITION_DESCRIPTION.DELETE,
        OPERATIONS[EBAY].CONDITION_DESCRIPTION.SET,
      ]),
    }),
    [MENU_ITEM.DESCRIPTION]: Map({
      controls: 'Description',
      productRow: 'Description',
      operations: List([
        OPERATIONS[EBAY].DESCRIPTION.AI_GENERATED,
        OPERATIONS[EBAY].DESCRIPTION.ADD_BEFORE,
        OPERATIONS[EBAY].DESCRIPTION.ADD_AFTER,
        OPERATIONS[EBAY].DESCRIPTION.FIND_AND_REPLACE,
        OPERATIONS[EBAY].DESCRIPTION.DELETE,
        OPERATIONS[EBAY].DESCRIPTION.SET,
      ]),
    }),
    [MENU_ITEM.ITEM_LOCATION]: Map({
      controls: 'ProductShipping',
      productRow: 'ProductShipping',
    }),
    [MENU_ITEM.ITEM_SIZE]: Map({
      controls: 'ProductShipping',
      productRow: 'ProductShipping',
      operations: List([
        OPERATIONS[EBAY].SIZE.INCREASE_BY,
        OPERATIONS[EBAY].SIZE.DECREASE_BY,
        OPERATIONS[EBAY].SIZE.SET,
      ]),
    }),
    [MENU_ITEM.ITEM_WEIGHT]: Map({
      controls: 'ProductShipping',
      productRow: 'ProductShipping',
      operations: List([
        OPERATIONS[EBAY].WEIGHT.INCREASE_BY,
        OPERATIONS[EBAY].WEIGHT.DECREASE_BY,
        OPERATIONS[EBAY].WEIGHT.SET,
      ]),
    }),
    [MENU_ITEM.PAYMENT_POLICY]: Map({
      controls: 'ProductShipping',
      productRow: 'PaymentPolicy',
    }),
    [MENU_ITEM.PHOTOS]: Map({
      controls: 'Photos',
      productRow: 'Photos',
      operations: List([
        OPERATIONS[EBAY].PHOTOS.ADD,
        OPERATIONS[EBAY].PHOTOS.REPLACE,
        OPERATIONS[EBAY].PHOTOS.DELETE,
      ]),
    }),
    [MENU_ITEM.PRICE]: Map({
      controls: 'Price',
      productRow: 'Price',
      operations: List([
        OPERATIONS[EBAY].PRICE.INCREASE_BY,
        OPERATIONS[EBAY].PRICE.DECREASE_BY,
        OPERATIONS[EBAY].PRICE.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.QUANTITY]: Map({
      controls: 'Quantity',
      productRow: 'Quantity',
      operations: List([
        OPERATIONS[EBAY].QUANTITY.INCREASE_BY,
        OPERATIONS[EBAY].QUANTITY.DECREASE_BY,
        OPERATIONS[EBAY].QUANTITY.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.RETURN_POLICY]: Map({
      controls: 'ProductShipping',
      productRow: 'ProductShipping',
    }),
    [MENU_ITEM.SHIPPING_POLICY]: Map({
      controls: 'ProductShipping',
      productRow: 'ProductShipping',
    }),
    [MENU_ITEM.SKU]: Map({
      controls: 'Sku',
      productRow: 'Sku',
      operations: List([
        OPERATIONS[EBAY].SKU.ADD_BEFORE,
        OPERATIONS[EBAY].SKU.ADD_AFTER,
        OPERATIONS[EBAY].SKU.FIND_AND_REPLACE,
        OPERATIONS[EBAY].SKU.DELETE,
        OPERATIONS[EBAY].SKU.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.STORE_CATEGORY]: Map({
      controls: 'StoreCategory',
      productRow: 'StoreCategory',
    }),
    [MENU_ITEM.TAXONOMY]: Map({
      controls: 'ItemSpecifics',
      productRow: 'ItemSpecifics',
      isTaxonomy: true,
    }),
    [MENU_ITEM.TITLE]: Map({
      controls: 'Title',
      productRow: 'Title',
      operations: List([
        OPERATIONS[EBAY].TITLE.AI_GENERATED,
        OPERATIONS[EBAY].TITLE.ADD_BEFORE,
        OPERATIONS[EBAY].TITLE.ADD_AFTER,
        OPERATIONS[EBAY].TITLE.FIND_AND_REPLACE,
        OPERATIONS[EBAY].TITLE.DELETE,
        OPERATIONS[EBAY].TITLE.SET,
      ]),
    }),
    [MENU_ITEM.VARIATIONS]: Map({
      controls: 'Variations',
      productRow: 'Variations',
    }),
    [MENU_ITEM.VIDEOS]: Map({
      controls: 'Videos',
      productRow: 'Videos',
      operations: List([
        OPERATIONS[EBAY].VIDEOS.ADD,
        OPERATIONS[EBAY].VIDEOS.REPLACE,
        OPERATIONS[EBAY].VIDEOS.DELETE,
      ]),
    }),
  }),
  [ETSY]: Map({
    [MENU_ITEM.ABOUT]: Map({
      controls: 'About',
      productRow: 'About',
    }),
    [MENU_ITEM.CATEGORY]: Map({
      controls: 'Category',
      productRow: 'Category',
    }),
    [MENU_ITEM.DESCRIPTION]: Map({
      controls: 'Description',
      productRow: 'Description',
      operations: List([
        OPERATIONS[ETSY].DESCRIPTION.AI_GENERATED,
        OPERATIONS[ETSY].DESCRIPTION.ADD_BEFORE,
        OPERATIONS[ETSY].DESCRIPTION.ADD_AFTER,
        OPERATIONS[ETSY].DESCRIPTION.FIND_AND_REPLACE,
        OPERATIONS[ETSY].DESCRIPTION.DELETE,
        OPERATIONS[ETSY].DESCRIPTION.SET,
      ]),
    }),
    [MENU_ITEM.FILES]: Map({
      controls: 'Files',
      productRow: 'Files',
      filters: Map({ [FILTER[ETSY].IS_DIGITAL]: true }),
      operations: List([
        OPERATIONS[ETSY].FILES.ADD,
        OPERATIONS[ETSY].FILES.REPLACE,
        OPERATIONS[ETSY].FILES.DELETE,
      ]),
    }),
    [MENU_ITEM.ITEM_SIZE]: Map({
      controls: 'ProductShipping',
      productRow: 'ProductShipping',
      filters: Map({ [FILTER[ETSY].IS_DIGITAL]: false }),
      operations: List([
        OPERATIONS[ETSY].SIZE.INCREASE_BY,
        OPERATIONS[ETSY].SIZE.DECREASE_BY,
        OPERATIONS[ETSY].SIZE.SET,
      ]),
    }),
    [MENU_ITEM.ITEM_WEIGHT]: Map({
      controls: 'ProductShipping',
      productRow: 'ProductShipping',
      filters: Map({ [FILTER[ETSY].IS_DIGITAL]: false }),
      operations: List([
        OPERATIONS[ETSY].WEIGHT.INCREASE_BY,
        OPERATIONS[ETSY].WEIGHT.DECREASE_BY,
        OPERATIONS[ETSY].WEIGHT.SET,
      ]),
    }),
    [MENU_ITEM.MATERIALS]: Map({
      controls: 'Materials',
      productRow: 'Materials',
      operations: List([
        OPERATIONS[ETSY].MATERIALS.ADD,
        OPERATIONS[ETSY].MATERIALS.DELETE,
      ]),
    }),
    [MENU_ITEM.PERSONALIZATION]: Map({
      controls: 'Personalization',
      productRow: 'Personalization',
      operations: List([
        OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_ADD_BEFORE,
        OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_ADD_AFTER,
        OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_FIND_AND_REPLACE,
        OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_DELETE,
        OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_SET,
      ]),
    }),
    [MENU_ITEM.PHOTOS]: Map({
      controls: 'Photos',
      productRow: 'Photos',
      operations: List([
        OPERATIONS[ETSY].PHOTOS.ADD,
        OPERATIONS[ETSY].PHOTOS.REPLACE,
        OPERATIONS[ETSY].PHOTOS.DELETE,
      ]),
    }),
    [MENU_ITEM.PRICE]: Map({
      controls: 'Price',
      productRow: 'Price',
      operations: List([
        OPERATIONS[ETSY].PRICE.INCREASE_BY,
        OPERATIONS[ETSY].PRICE.DECREASE_BY,
        OPERATIONS[ETSY].PRICE.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.PROCESSING_PROFILE]: Map({
      controls: 'ProcessingProfile',
      productRow: 'ProcessingProfile',
      filters: Map({ [FILTER[ETSY].IS_DIGITAL]: false }),
    }),
    [MENU_ITEM.PRODUCTION_PARTNER]: Map({
      controls: 'ProductionPartner',
      productRow: 'ProductionPartner',
    }),
    [MENU_ITEM.QUANTITY]: Map({
      controls: 'Quantity',
      productRow: 'Quantity',
      operations: List([
        OPERATIONS[ETSY].QUANTITY.INCREASE_BY,
        OPERATIONS[ETSY].QUANTITY.DECREASE_BY,
        OPERATIONS[ETSY].QUANTITY.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.RETURN_POLICY]: Map({
      controls: 'ProductShipping',
      productRow: 'ReturnPolicy',
      filters: Map({ [FILTER[ETSY].IS_DIGITAL]: false }),
    }),
    [MENU_ITEM.SECTION]: Map({
      controls: 'Section',
      productRow: 'Section',
    }),
    [MENU_ITEM.SHIPPING_PROFILE]: Map({
      controls: 'ProductShipping',
      productRow: 'ProductShipping',
      filters: Map({ [FILTER[ETSY].IS_DIGITAL]: false }),
    }),
    [MENU_ITEM.SKU]: Map({
      controls: 'Sku',
      productRow: 'Sku',
      operations: List([
        OPERATIONS[ETSY].SKU.ADD_BEFORE,
        OPERATIONS[ETSY].SKU.ADD_AFTER,
        OPERATIONS[ETSY].SKU.FIND_AND_REPLACE,
        OPERATIONS[ETSY].SKU.DELETE,
        OPERATIONS[ETSY].SKU.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.TAGS]: Map({
      controls: 'Tags',
      productRow: 'Tags',
      operations: List([
        OPERATIONS[ETSY].TAGS.AI_GENERATED,
        OPERATIONS[ETSY].TAGS.ADD,
        OPERATIONS[ETSY].TAGS.DELETE,
        OPERATIONS[ETSY].TAGS.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.TAXONOMY]: Map({
      controls: 'TaxonomyAttributes',
      productRow: 'TaxonomyAttributes',
      isTaxonomy: true,
    }),
    [MENU_ITEM.TITLE]: Map({
      controls: 'Title',
      productRow: 'Title',
      operations: List([
        OPERATIONS[ETSY].TITLE.AI_GENERATED,
        OPERATIONS[ETSY].TITLE.ADD_BEFORE,
        OPERATIONS[ETSY].TITLE.ADD_AFTER,
        OPERATIONS[ETSY].TITLE.FIND_AND_REPLACE,
        OPERATIONS[ETSY].TITLE.DELETE,
        OPERATIONS[ETSY].TITLE.SET,
      ]),
    }),
    [MENU_ITEM.VARIATIONS]: Map({
      controls: 'Variations',
      productRow: 'Variations',
      filters: Map({ [FILTER[ETSY].IS_DIGITAL]: false }),
    }),
    [MENU_ITEM.VIDEOS]: Map({
      controls: 'Videos',
      productRow: 'Videos',
      operations: List([
        OPERATIONS[ETSY].VIDEOS.ADD,
        OPERATIONS[ETSY].VIDEOS.REPLACE,
        OPERATIONS[ETSY].VIDEOS.DELETE,
      ]),
    }),
  }),
  [FAIRE]: Map({
    [MENU_ITEM.AVAILABILITY]: Map({
      controls: 'Availability',
      productRow: 'Availability',
    }),
    [MENU_ITEM.CATEGORY]: Map({
      controls: 'Category',
      productRow: 'Category',
    }),
    [MENU_ITEM.DESCRIPTION]: Map({
      controls: 'Description',
      productRow: 'Description',
      operations: List([
        OPERATIONS[FAIRE].DESCRIPTION.AI_GENERATED,
        OPERATIONS[FAIRE].DESCRIPTION.ADD_BEFORE,
        OPERATIONS[FAIRE].DESCRIPTION.ADD_AFTER,
        OPERATIONS[FAIRE].DESCRIPTION.FIND_AND_REPLACE,
        OPERATIONS[FAIRE].DESCRIPTION.DELETE,
        OPERATIONS[FAIRE].DESCRIPTION.SET,
      ]),
    }),
    [MENU_ITEM.GTIN]: Map({
      controls: 'Gtin',
      productRow: 'Gtin',
      operations: List([
        OPERATIONS[FAIRE].GTIN.ADD_BEFORE,
        OPERATIONS[FAIRE].GTIN.ADD_AFTER,
        OPERATIONS[FAIRE].GTIN.FIND_AND_REPLACE,
        OPERATIONS[FAIRE].GTIN.DELETE,
        OPERATIONS[FAIRE].GTIN.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.ITEM_SIZE]: Map({
      controls: 'InventoryShipping',
      productRow: 'InventoryShipping',
      operations: List([
        OPERATIONS[FAIRE].SIZE.INCREASE_BY,
        OPERATIONS[FAIRE].SIZE.DECREASE_BY,
        OPERATIONS[FAIRE].SIZE.SET,
      ]),
    }),
    [MENU_ITEM.ITEM_WEIGHT]: Map({
      controls: 'InventoryShipping',
      productRow: 'InventoryShipping',
      operations: List([
        OPERATIONS[FAIRE].WEIGHT.INCREASE_BY,
        OPERATIONS[FAIRE].WEIGHT.DECREASE_BY,
        OPERATIONS[FAIRE].WEIGHT.SET,
      ]),
    }),
    [MENU_ITEM.PHOTOS]: Map({
      controls: 'Photos',
      productRow: 'Photos',
      operations: List([
        OPERATIONS[FAIRE].PHOTOS.ADD,
        OPERATIONS[FAIRE].PHOTOS.REPLACE,
        OPERATIONS[FAIRE].PHOTOS.DELETE,
      ]),
    }),
    [MENU_ITEM.PRICE]: Map({
      controls: 'Price',
      productRow: 'Price',
      operations: List([
        OPERATIONS[FAIRE].PRICES.INCREASE_BY,
        OPERATIONS[FAIRE].PRICES.DECREASE_BY,
        OPERATIONS[FAIRE].PRICES.SET,
      ]),
    }),
    [MENU_ITEM.QUANTITY]: Map({
      controls: 'Quantity',
      productRow: 'Quantity',
      operations: List([
        OPERATIONS[FAIRE].QUANTITY.INCREASE_BY,
        OPERATIONS[FAIRE].QUANTITY.DECREASE_BY,
        OPERATIONS[FAIRE].QUANTITY.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.SELLING_METHOD]: Map({
      controls: 'ProductShipping',
      productRow: 'ProductShipping',
    }),
    [MENU_ITEM.SKU]: Map({
      controls: 'Sku',
      productRow: 'Sku',
      operations: List([
        OPERATIONS[FAIRE].SKU.ADD_BEFORE,
        OPERATIONS[FAIRE].SKU.ADD_AFTER,
        OPERATIONS[FAIRE].SKU.FIND_AND_REPLACE,
        OPERATIONS[FAIRE].SKU.DELETE,
        OPERATIONS[FAIRE].SKU.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.TARIFF_CODE]: Map({
      controls: 'InventoryShipping',
      productRow: 'InventoryShipping',
    }),
    [MENU_ITEM.TITLE]: Map({
      controls: 'Title',
      productRow: 'Title',
      operations: List([
        OPERATIONS[FAIRE].TITLE.AI_GENERATED,
        OPERATIONS[FAIRE].TITLE.ADD_BEFORE,
        OPERATIONS[FAIRE].TITLE.ADD_AFTER,
        OPERATIONS[FAIRE].TITLE.FIND_AND_REPLACE,
        OPERATIONS[FAIRE].TITLE.DELETE,
        OPERATIONS[FAIRE].TITLE.SET,
      ]),
    }),
    [MENU_ITEM.VARIATIONS]: Map({
      controls: 'Variations',
      productRow: 'Variations',
    }),
  }),
  [SHOPIFY]: Map({
    [MENU_ITEM.BARCODE]: Map({
      controls: 'Barcode',
      productRow: 'Barcode',
      operations: List([
        OPERATIONS[SHOPIFY].BARCODE.ADD_BEFORE,
        OPERATIONS[SHOPIFY].BARCODE.ADD_AFTER,
        OPERATIONS[SHOPIFY].BARCODE.FIND_AND_REPLACE,
        OPERATIONS[SHOPIFY].BARCODE.DELETE,
        OPERATIONS[SHOPIFY].BARCODE.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.BODY_HTML]: Map({
      controls: 'Description',
      productRow: 'Description',
      operations: List([
        OPERATIONS[SHOPIFY].DESCRIPTION.AI_GENERATED,
        OPERATIONS[SHOPIFY].DESCRIPTION.ADD_BEFORE,
        OPERATIONS[SHOPIFY].DESCRIPTION.ADD_AFTER,
        OPERATIONS[SHOPIFY].DESCRIPTION.FIND_AND_REPLACE,
        OPERATIONS[SHOPIFY].DESCRIPTION.DELETE,
        OPERATIONS[SHOPIFY].DESCRIPTION.SET,
      ]),
    }),
    [MENU_ITEM.CAP]: Map({
      controls: 'Price',
      productRow: 'Price',
      operations: List([
        OPERATIONS[SHOPIFY].CAP.INCREASE_BY,
        OPERATIONS[SHOPIFY].CAP.DECREASE_BY,
        OPERATIONS[SHOPIFY].CAP.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.CATEGORY]: Map({
      controls: 'Category',
      productRow: 'Category',
    }),
    [MENU_ITEM.COLLECTIONS]: Map({
      controls: 'Collections',
      productRow: 'Collections',
    }),
    [MENU_ITEM.COUNTRY_CODE]: Map({
      controls: 'InventoryShipping',
      productRow: 'InventoryShipping',
    }),
    [MENU_ITEM.CPI]: Map({
      controls: 'Price',
      productRow: 'Price',
      operations: List([
        OPERATIONS[SHOPIFY].CPI.INCREASE_BY,
        OPERATIONS[SHOPIFY].CPI.DECREASE_BY,
        OPERATIONS[SHOPIFY].CPI.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.HS_CODE]: Map({
      controls: 'InventoryShipping',
      productRow: 'InventoryShipping',
    }),
    [MENU_ITEM.META_DESCRIPTION]: Map({
      controls: 'SEOListing',
      productRow: 'SEOListing',
      operations: List([
        OPERATIONS[SHOPIFY].META_DESCRIPTION.AI_GENERATED,
        OPERATIONS[SHOPIFY].META_DESCRIPTION.ADD_BEFORE,
        OPERATIONS[SHOPIFY].META_DESCRIPTION.ADD_AFTER,
        OPERATIONS[SHOPIFY].META_DESCRIPTION.FIND_AND_REPLACE,
        OPERATIONS[SHOPIFY].META_DESCRIPTION.DELETE,
        OPERATIONS[SHOPIFY].META_DESCRIPTION.SET,
      ]),
    }),
    [MENU_ITEM.PAGE_TITLE]: Map({
      controls: 'SEOListing',
      productRow: 'SEOListing',
      operations: List([
        OPERATIONS[SHOPIFY].PAGE_TITLE.AI_GENERATED,
        OPERATIONS[SHOPIFY].PAGE_TITLE.ADD_BEFORE,
        OPERATIONS[SHOPIFY].PAGE_TITLE.ADD_AFTER,
        OPERATIONS[SHOPIFY].PAGE_TITLE.FIND_AND_REPLACE,
        OPERATIONS[SHOPIFY].PAGE_TITLE.DELETE,
        OPERATIONS[SHOPIFY].PAGE_TITLE.SET,
      ]),
    }),
    [MENU_ITEM.PHOTOS]: Map({
      controls: 'Photos',
      productRow: 'Photos',
      operations: List([
        OPERATIONS[SHOPIFY].PHOTOS.ADD,
        OPERATIONS[SHOPIFY].PHOTOS.REPLACE,
        OPERATIONS[SHOPIFY].PHOTOS.DELETE,
      ]),
    }),
    [MENU_ITEM.PRICE]: Map({
      controls: 'Price',
      productRow: 'Price',
      operations: List([
        OPERATIONS[SHOPIFY].PRICE.INCREASE_BY,
        OPERATIONS[SHOPIFY].PRICE.DECREASE_BY,
        OPERATIONS[SHOPIFY].PRICE.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.PRODUCT_TYPE]: Map({
      controls: 'ProductType',
      productRow: 'ProductType',
    }),
    [MENU_ITEM.QUANTITY]: Map({
      controls: 'Quantity',
      productRow: 'Quantity',
      operations: List([
        OPERATIONS[SHOPIFY].QUANTITY.INCREASE_BY,
        OPERATIONS[SHOPIFY].QUANTITY.DECREASE_BY,
        OPERATIONS[SHOPIFY].QUANTITY.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.SKU]: Map({
      controls: 'Sku',
      productRow: 'Sku',
      operations: List([
        OPERATIONS[SHOPIFY].SKU.ADD_BEFORE,
        OPERATIONS[SHOPIFY].SKU.ADD_AFTER,
        OPERATIONS[SHOPIFY].SKU.FIND_AND_REPLACE,
        OPERATIONS[SHOPIFY].SKU.DELETE,
        OPERATIONS[SHOPIFY].SKU.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.TAGS]: Map({
      controls: 'Tags',
      productRow: 'Tags',
      operations: List([
        OPERATIONS[SHOPIFY].TAGS.ADD,
        OPERATIONS[SHOPIFY].TAGS.DELETE,
        OPERATIONS[SHOPIFY].TAGS.CHANGE_TO,
      ]),
    }),
    [MENU_ITEM.TITLE]: Map({
      controls: 'Title',
      productRow: 'Title',
      operations: List([
        OPERATIONS[SHOPIFY].TITLE.AI_GENERATED,
        OPERATIONS[SHOPIFY].TITLE.ADD_BEFORE,
        OPERATIONS[SHOPIFY].TITLE.ADD_AFTER,
        OPERATIONS[SHOPIFY].TITLE.FIND_AND_REPLACE,
        OPERATIONS[SHOPIFY].TITLE.DELETE,
        OPERATIONS[SHOPIFY].TITLE.SET,
      ]),
    }),
    [MENU_ITEM.VARIATIONS]: Map({
      controls: 'Variations',
      productRow: 'Variations',
    }),
    [MENU_ITEM.VENDOR]: Map({
      controls: 'Vendor',
      productRow: 'Vendor',
    }),
    [MENU_ITEM.VIDEOS]: Map({
      controls: 'Videos',
      productRow: 'Videos',
      operations: List([
        OPERATIONS[SHOPIFY].VIDEOS.ADD,
        OPERATIONS[SHOPIFY].VIDEOS.REPLACE,
        OPERATIONS[SHOPIFY].VIDEOS.DELETE,
      ]),
    }),
    [MENU_ITEM.WEIGHT]: Map({
      controls: 'InventoryShipping',
      productRow: 'InventoryShipping',
      operations: List([
        OPERATIONS[SHOPIFY].WEIGHT.INCREASE_BY,
        OPERATIONS[SHOPIFY].WEIGHT.DECREASE_BY,
        OPERATIONS[SHOPIFY].WEIGHT.CHANGE_TO,
      ]),
    }),
  }),
};

export const OPERATION_NAME = {
  ADD: 'Add',
  ADD_AFTER: 'Add after',
  ADD_BEFORE: 'Add before',
  AI_GENERATED: 'AI Generated',
  ALT_TEXT: 'Alt text',
  CHANGE_TO: 'Change to',
  DECREASE_BY: 'Decrease by',
  DELETE: 'Delete',
  FIND_AND_REPLACE: 'Find & Replace',
  INCREASE_BY: 'Increase by',
  REPLACE: 'Replace',
  VELA_AI: 'Vela AI',
};

export const MENU_OPERATION_NAMES = {
  [EBAY]: {
    [MENU_ITEM.CONDITION]: {
      [OPERATIONS[EBAY].CONDITION_DESCRIPTION.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[EBAY].CONDITION_DESCRIPTION.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[EBAY].CONDITION_DESCRIPTION.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[EBAY].CONDITION_DESCRIPTION.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
      [OPERATIONS[EBAY].CONDITION_DESCRIPTION.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.DESCRIPTION]: {
      [OPERATIONS[EBAY].DESCRIPTION.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[EBAY].DESCRIPTION.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[EBAY].DESCRIPTION.AI_GENERATED]: OPERATION_NAME.VELA_AI,
      [OPERATIONS[EBAY].DESCRIPTION.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[EBAY].DESCRIPTION.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
      [OPERATIONS[EBAY].DESCRIPTION.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.ITEM_SIZE]: {
      [OPERATIONS[EBAY].SIZE.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[EBAY].SIZE.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
      [OPERATIONS[EBAY].SIZE.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.ITEM_WEIGHT]: {
      [OPERATIONS[EBAY].WEIGHT.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[EBAY].WEIGHT.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
      [OPERATIONS[EBAY].WEIGHT.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.PHOTOS]: {
      [OPERATIONS[EBAY].PHOTOS.ADD]: OPERATION_NAME.ADD,
      [OPERATIONS[EBAY].PHOTOS.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[EBAY].PHOTOS.REPLACE]: OPERATION_NAME.REPLACE,
    },
    [MENU_ITEM.PRICE]: {
      [OPERATIONS[EBAY].PRICE.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
      [OPERATIONS[EBAY].PRICE.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[EBAY].PRICE.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
    },
    [MENU_ITEM.QUANTITY]: {
      [OPERATIONS[EBAY].QUANTITY.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
      [OPERATIONS[EBAY].QUANTITY.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[EBAY].QUANTITY.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
    },
    [MENU_ITEM.SKU]: {
      [OPERATIONS[EBAY].SKU.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[EBAY].SKU.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[EBAY].SKU.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
      [OPERATIONS[EBAY].SKU.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[EBAY].SKU.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
    },
    [MENU_ITEM.TITLE]: {
      [OPERATIONS[EBAY].TITLE.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[EBAY].TITLE.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[EBAY].TITLE.AI_GENERATED]: OPERATION_NAME.VELA_AI,
      [OPERATIONS[EBAY].TITLE.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[EBAY].TITLE.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
      [OPERATIONS[EBAY].TITLE.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.VIDEOS]: {
      [OPERATIONS[EBAY].VIDEOS.ADD]: OPERATION_NAME.ADD,
      [OPERATIONS[EBAY].VIDEOS.REPLACE]: OPERATION_NAME.REPLACE,
      [OPERATIONS[EBAY].VIDEOS.DELETE]: OPERATION_NAME.DELETE,
    },
  },
  [ETSY]: {
    [MENU_ITEM.DESCRIPTION]: {
      [OPERATIONS[ETSY].DESCRIPTION.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[ETSY].DESCRIPTION.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[ETSY].DESCRIPTION.AI_GENERATED]: OPERATION_NAME.VELA_AI,
      [OPERATIONS[ETSY].DESCRIPTION.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[ETSY].DESCRIPTION.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
      [OPERATIONS[ETSY].DESCRIPTION.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.FILES]: {
      [OPERATIONS[ETSY].FILES.ADD]: OPERATION_NAME.ADD,
      [OPERATIONS[ETSY].FILES.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[ETSY].FILES.REPLACE]: OPERATION_NAME.REPLACE,
    },
    [MENU_ITEM.ITEM_SIZE]: {
      [OPERATIONS[ETSY].SIZE.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[ETSY].SIZE.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
      [OPERATIONS[ETSY].SIZE.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.ITEM_WEIGHT]: {
      [OPERATIONS[ETSY].WEIGHT.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[ETSY].WEIGHT.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
      [OPERATIONS[ETSY].WEIGHT.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.MATERIALS]: {
      [OPERATIONS[ETSY].MATERIALS.ADD]: OPERATION_NAME.ADD,
      [OPERATIONS[ETSY].MATERIALS.DELETE]: OPERATION_NAME.DELETE,
    },
    [MENU_ITEM.PERSONALIZATION]: {
      [OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
      [OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.PHOTOS]: {
      [OPERATIONS[ETSY].PHOTOS.ADD]: OPERATION_NAME.ADD,
      [OPERATIONS[ETSY].PHOTOS.ALT_TEXT]: OPERATION_NAME.ALT_TEXT,
      [OPERATIONS[ETSY].PHOTOS.ALT_TEXT_AI_GENERATED]: OPERATION_NAME.ALT_TEXT,
      [OPERATIONS[ETSY].PHOTOS.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[ETSY].PHOTOS.REPLACE]: OPERATION_NAME.REPLACE,
    },
    [MENU_ITEM.PRICE]: {
      [OPERATIONS[ETSY].PRICE.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
      [OPERATIONS[ETSY].PRICE.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[ETSY].PRICE.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
    },
    [MENU_ITEM.QUANTITY]: {
      [OPERATIONS[ETSY].QUANTITY.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
      [OPERATIONS[ETSY].QUANTITY.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[ETSY].QUANTITY.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
    },
    [MENU_ITEM.SKU]: {
      [OPERATIONS[ETSY].SKU.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[ETSY].SKU.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[ETSY].SKU.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
      [OPERATIONS[ETSY].SKU.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[ETSY].SKU.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
    },
    [MENU_ITEM.TAGS]: {
      [OPERATIONS[ETSY].TAGS.ADD]: OPERATION_NAME.ADD,
      [OPERATIONS[ETSY].TAGS.AI_GENERATED]: OPERATION_NAME.VELA_AI,
      [OPERATIONS[ETSY].TAGS.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[ETSY].TAGS.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.TITLE]: {
      [OPERATIONS[ETSY].TITLE.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[ETSY].TITLE.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[ETSY].TITLE.AI_GENERATED]: OPERATION_NAME.VELA_AI,
      [OPERATIONS[ETSY].TITLE.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[ETSY].TITLE.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
      [OPERATIONS[ETSY].TITLE.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.VIDEOS]: {
      [OPERATIONS[ETSY].VIDEOS.ADD]: OPERATION_NAME.ADD,
      [OPERATIONS[ETSY].VIDEOS.REPLACE]: OPERATION_NAME.REPLACE,
      [OPERATIONS[ETSY].VIDEOS.DELETE]: OPERATION_NAME.DELETE,
    },
  },
  [FAIRE]: {
    [MENU_ITEM.DESCRIPTION]: {
      [OPERATIONS[FAIRE].DESCRIPTION.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[FAIRE].DESCRIPTION.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[FAIRE].DESCRIPTION.AI_GENERATED]: OPERATION_NAME.VELA_AI,
      [OPERATIONS[FAIRE].DESCRIPTION.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[FAIRE].DESCRIPTION.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
      [OPERATIONS[FAIRE].DESCRIPTION.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.GTIN]: {
      [OPERATIONS[FAIRE].GTIN.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[FAIRE].GTIN.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[FAIRE].GTIN.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
      [OPERATIONS[FAIRE].GTIN.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[FAIRE].GTIN.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
    },
    [MENU_ITEM.ITEM_SIZE]: {
      [OPERATIONS[FAIRE].SIZE.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[FAIRE].SIZE.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
      [OPERATIONS[FAIRE].SIZE.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.ITEM_WEIGHT]: {
      [OPERATIONS[FAIRE].WEIGHT.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[FAIRE].WEIGHT.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
      [OPERATIONS[FAIRE].WEIGHT.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.PHOTOS]: {
      [OPERATIONS[FAIRE].PHOTOS.ADD]: OPERATION_NAME.ADD,
      [OPERATIONS[FAIRE].PHOTOS.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[FAIRE].PHOTOS.REPLACE]: OPERATION_NAME.REPLACE,
    },
    [MENU_ITEM.PRICE]: {
      [OPERATIONS[FAIRE].PRICES.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[FAIRE].PRICES.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
      [OPERATIONS[FAIRE].PRICES.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.QUANTITY]: {
      [OPERATIONS[FAIRE].QUANTITY.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
      [OPERATIONS[FAIRE].QUANTITY.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[FAIRE].QUANTITY.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
    },
    [MENU_ITEM.SKU]: {
      [OPERATIONS[FAIRE].SKU.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[FAIRE].SKU.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[FAIRE].SKU.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
      [OPERATIONS[FAIRE].SKU.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[FAIRE].SKU.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
    },
    [MENU_ITEM.TITLE]: {
      [OPERATIONS[FAIRE].TITLE.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[FAIRE].TITLE.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[FAIRE].TITLE.AI_GENERATED]: OPERATION_NAME.VELA_AI,
      [OPERATIONS[FAIRE].TITLE.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[FAIRE].TITLE.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
      [OPERATIONS[FAIRE].TITLE.SET]: OPERATION_NAME.CHANGE_TO,
    },
  },
  [SHOPIFY]: {
    [MENU_ITEM.BARCODE]: {
      [OPERATIONS[SHOPIFY].BARCODE.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[SHOPIFY].BARCODE.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[SHOPIFY].BARCODE.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
      [OPERATIONS[SHOPIFY].BARCODE.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[SHOPIFY].BARCODE.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
    },
    [MENU_ITEM.BODY_HTML]: {
      [OPERATIONS[SHOPIFY].DESCRIPTION.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[SHOPIFY].DESCRIPTION.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[SHOPIFY].DESCRIPTION.AI_GENERATED]: OPERATION_NAME.VELA_AI,
      [OPERATIONS[SHOPIFY].DESCRIPTION.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[SHOPIFY].DESCRIPTION.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
      [OPERATIONS[SHOPIFY].DESCRIPTION.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.CAP]: {
      [OPERATIONS[SHOPIFY].CAP.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
      [OPERATIONS[SHOPIFY].CAP.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[SHOPIFY].CAP.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
    },
    [MENU_ITEM.CPI]: {
      [OPERATIONS[SHOPIFY].CPI.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
      [OPERATIONS[SHOPIFY].CPI.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[SHOPIFY].CPI.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
    },
    [MENU_ITEM.META_DESCRIPTION]: {
      [OPERATIONS[SHOPIFY].META_DESCRIPTION.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[SHOPIFY].META_DESCRIPTION.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[SHOPIFY].META_DESCRIPTION.AI_GENERATED]: OPERATION_NAME.VELA_AI,
      [OPERATIONS[SHOPIFY].META_DESCRIPTION.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[SHOPIFY].META_DESCRIPTION.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
      [OPERATIONS[SHOPIFY].META_DESCRIPTION.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.PAGE_TITLE]: {
      [OPERATIONS[SHOPIFY].PAGE_TITLE.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[SHOPIFY].PAGE_TITLE.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[SHOPIFY].PAGE_TITLE.AI_GENERATED]: OPERATION_NAME.VELA_AI,
      [OPERATIONS[SHOPIFY].PAGE_TITLE.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[SHOPIFY].PAGE_TITLE.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
      [OPERATIONS[SHOPIFY].PAGE_TITLE.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.PHOTOS]: {
      [OPERATIONS[SHOPIFY].PHOTOS.ADD]: OPERATION_NAME.ADD,
      [OPERATIONS[SHOPIFY].PHOTOS.ALT_TEXT]: OPERATION_NAME.ALT_TEXT,
      [OPERATIONS[SHOPIFY].PHOTOS.ALT_TEXT_AI_GENERATED]: OPERATION_NAME.ALT_TEXT,
      [OPERATIONS[SHOPIFY].PHOTOS.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[SHOPIFY].PHOTOS.REPLACE]: OPERATION_NAME.REPLACE,
    },
    [MENU_ITEM.PRICE]: {
      [OPERATIONS[SHOPIFY].PRICE.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
      [OPERATIONS[SHOPIFY].PRICE.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[SHOPIFY].PRICE.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
    },
    [MENU_ITEM.QUANTITY]: {
      [OPERATIONS[SHOPIFY].QUANTITY.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
      [OPERATIONS[SHOPIFY].QUANTITY.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[SHOPIFY].QUANTITY.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
    },
    [MENU_ITEM.SKU]: {
      [OPERATIONS[SHOPIFY].SKU.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[SHOPIFY].SKU.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[SHOPIFY].SKU.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
      [OPERATIONS[SHOPIFY].SKU.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[SHOPIFY].SKU.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
    },
    [MENU_ITEM.TAGS]: {
      [OPERATIONS[SHOPIFY].TAGS.ADD]: OPERATION_NAME.ADD,
      [OPERATIONS[SHOPIFY].TAGS.AI_GENERATED]: OPERATION_NAME.VELA_AI,
      [OPERATIONS[SHOPIFY].TAGS.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[SHOPIFY].TAGS.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.TITLE]: {
      [OPERATIONS[SHOPIFY].TITLE.ADD_AFTER]: OPERATION_NAME.ADD_AFTER,
      [OPERATIONS[SHOPIFY].TITLE.ADD_BEFORE]: OPERATION_NAME.ADD_BEFORE,
      [OPERATIONS[SHOPIFY].TITLE.AI_GENERATED]: OPERATION_NAME.VELA_AI,
      [OPERATIONS[SHOPIFY].TITLE.DELETE]: OPERATION_NAME.DELETE,
      [OPERATIONS[SHOPIFY].TITLE.FIND_AND_REPLACE]: OPERATION_NAME.FIND_AND_REPLACE,
      [OPERATIONS[SHOPIFY].TITLE.SET]: OPERATION_NAME.CHANGE_TO,
    },
    [MENU_ITEM.VIDEOS]: {
      [OPERATIONS[SHOPIFY].VIDEOS.ADD]: OPERATION_NAME.ADD,
      [OPERATIONS[SHOPIFY].VIDEOS.REPLACE]: OPERATION_NAME.REPLACE,
      [OPERATIONS[SHOPIFY].VIDEOS.DELETE]: OPERATION_NAME.DELETE,
    },
    [MENU_ITEM.WEIGHT]: {
      [OPERATIONS[SHOPIFY].WEIGHT.CHANGE_TO]: OPERATION_NAME.CHANGE_TO,
      [OPERATIONS[SHOPIFY].WEIGHT.DECREASE_BY]: OPERATION_NAME.DECREASE_BY,
      [OPERATIONS[SHOPIFY].WEIGHT.INCREASE_BY]: OPERATION_NAME.INCREASE_BY,
    },
  },
};

export const ATTRIBUTES_TO_MENU_ITEM_MAP = {
  [EBAY]: {
    category_id: MENU_ITEM.ITEM_CATEGORY,
    condition: MENU_ITEM.CONDITION,
    custom_category_id: MENU_ITEM.STORE_CATEGORY,
    description: MENU_ITEM.DESCRIPTION,
    item_location: MENU_ITEM.ITEM_LOCATION,
    item_size: MENU_ITEM.ITEM_SIZE,
    item_specifics: MENU_ITEM.TAXONOMY,
    item_weight: MENU_ITEM.ITEM_WEIGHT,
    payment_policy_id: MENU_ITEM.PAYMENT_POLICY,
    photos: MENU_ITEM.PHOTOS,
    price: MENU_ITEM.PRICE,
    quantity: MENU_ITEM.QUANTITY,
    return_policy_id: MENU_ITEM.RETURN_POLICY,
    shipping_policy_id: MENU_ITEM.SHIPPING_POLICY,
    sku: MENU_ITEM.SKU,
    title: MENU_ITEM.TITLE,
    variations: MENU_ITEM.VARIATIONS,
    videos: MENU_ITEM.VIDEOS,
  },
  [ETSY]: {
    about: MENU_ITEM.ABOUT,
    category: MENU_ITEM.CATEGORY,
    description: MENU_ITEM.DESCRIPTION,
    files: MENU_ITEM.FILES,
    item_dimensions: MENU_ITEM.ITEM_SIZE,
    item_weight: MENU_ITEM.ITEM_WEIGHT,
    materials: MENU_ITEM.MATERIALS,
    optional: MENU_ITEM.TAXONOMY,
    personalization: MENU_ITEM.PERSONALIZATION,
    photos: MENU_ITEM.PHOTOS,
    price: MENU_ITEM.PRICE,
    production_partners: MENU_ITEM.PRODUCTION_PARTNER,
    quantity: MENU_ITEM.QUANTITY,
    processing_profile: MENU_ITEM.PROCESSING_PROFILE,
    readiness_state_id: MENU_ITEM.PROCESSING_PROFILE,
    return_policy_id: MENU_ITEM.RETURN_POLICY,
    section: MENU_ITEM.SECTION,
    shipping_profile: MENU_ITEM.SHIPPING_PROFILE,
    sku: MENU_ITEM.SKU,
    tags: MENU_ITEM.TAGS,
    title: MENU_ITEM.TITLE,
    variations: MENU_ITEM.VARIATIONS,
  },
  [FAIRE]: {
    available_quantity: MENU_ITEM.QUANTITY,
    category_id: MENU_ITEM.CATEGORY,
    description: MENU_ITEM.DESCRIPTION,
    gtin: MENU_ITEM.GTIN,
    photos: MENU_ITEM.PHOTOS,
    prices: MENU_ITEM.PRICE,
    sku: MENU_ITEM.SKU,
    tariff_code: MENU_ITEM.TARIFF_CODE,
    title: MENU_ITEM.TITLE,
    variations: MENU_ITEM.VARIATIONS,
  },
  [SHOPIFY]: {
    barcode: MENU_ITEM.BARCODE,
    description: MENU_ITEM.BODY_HTML,
    compare_at_price: MENU_ITEM.CAP,
    collections: MENU_ITEM.COLLECTIONS,
    country_code_of_origin: MENU_ITEM.COUNTRY_CODE,
    cost: MENU_ITEM.CPI,
    harmonized_system_code: MENU_ITEM.HS_CODE,
    photos: MENU_ITEM.PHOTOS,
    price: MENU_ITEM.PRICE,
    product_type: MENU_ITEM.PRODUCT_TYPE,
    quantity: MENU_ITEM.QUANTITY,
    sku: MENU_ITEM.SKU,
    tags: MENU_ITEM.TAGS,
    title: MENU_ITEM.TITLE,
    variations: MENU_ITEM.VARIATIONS,
    vendor: MENU_ITEM.VENDOR,
    weight: MENU_ITEM.WEIGHT,
  },
};

export const MENU_ITEMS_TO_ATTRIBUTE_MAP = {
  [EBAY]: {
    [MENU_ITEM.ITEM_CATEGORY]: 'category_id',
    [MENU_ITEM.CONDITION]: 'condition',
    [MENU_ITEM.DESCRIPTION]: 'description',
    [MENU_ITEM.ITEM_LOCATION]: 'item_location',
    [MENU_ITEM.ITEM_SIZE]: 'item_size',
    [MENU_ITEM.TAXONOMY]: 'item_specifics',
    [MENU_ITEM.ITEM_WEIGHT]: 'item_weight',
    [MENU_ITEM.PAYMENT_POLICY]: 'payment_policy_id',
    [MENU_ITEM.PHOTOS]: 'photos',
    [MENU_ITEM.PRICE]: 'price',
    [MENU_ITEM.QUANTITY]: 'quantity',
    [MENU_ITEM.RETURN_POLICY]: 'return_policy_id',
    [MENU_ITEM.SHIPPING_POLICY]: 'shipping_policy_id',
    [MENU_ITEM.SKU]: 'sku',
    [MENU_ITEM.STORE_CATEGORY]: 'cusstom_category_id',
    [MENU_ITEM.TITLE]: 'title',
    [MENU_ITEM.VARIATIONS]: 'variations',
    [MENU_ITEM.VIDEOS]: 'videos',
  },
  [ETSY]: {
    [MENU_ITEM.ABOUT]: 'about',
    [MENU_ITEM.CATEGORY]: 'category',
    [MENU_ITEM.DESCRIPTION]: 'description',
    [MENU_ITEM.FILES]: 'files',
    [MENU_ITEM.ITEM_SIZE]: 'item_dimensions',
    [MENU_ITEM.ITEM_WEIGHT]: 'item_weight',
    [MENU_ITEM.TAXONOMY]: 'optional',
    [MENU_ITEM.MATERIALS]: 'materials',
    [MENU_ITEM.PERSONALIZATION]: 'personalization',
    [MENU_ITEM.PHOTOS]: 'photos',
    [MENU_ITEM.PRICE]: 'price',
    [MENU_ITEM.PRODUCTION_PARTNER]: 'production_partners',
    [MENU_ITEM.QUANTITY]: 'quantity',
    [MENU_ITEM.PROCESSING_PROFILE]: 'readiness_state_id',
    [MENU_ITEM.RETURN_POLICY]: 'return_policy_id',
    [MENU_ITEM.SECTION]: 'section',
    [MENU_ITEM.SHIPPING_PROFILE]: 'shipping_profile',
    [MENU_ITEM.SKU]: 'sku',
    [MENU_ITEM.TAGS]: 'tags',
    [MENU_ITEM.TITLE]: 'title',
    [MENU_ITEM.VARIATIONS]: 'variations',
  },
  [FAIRE]: {
    [MENU_ITEM.CATEGORY]: 'category_id',
    [MENU_ITEM.DESCRIPTION]: 'description',
    [MENU_ITEM.PHOTOS]: 'photos',
    [MENU_ITEM.PRICE]: 'prices',
    [MENU_ITEM.QUANTITY]: 'available_quantity',
    [MENU_ITEM.TARIFF_CODE]: 'tariff_code',
    [MENU_ITEM.TITLE]: 'title',
    [MENU_ITEM.VARIATIONS]: 'variations',
  },
  [SHOPIFY]: {
    [MENU_ITEM.BARCODE]: 'barcode',
    [MENU_ITEM.BODY_HTML]: 'description',
    [MENU_ITEM.CAP]: 'compare_at_price',
    [MENU_ITEM.COLLECTIONS]: 'collections',
    [MENU_ITEM.COUNTRY_CODE]: 'country_code_of_origin',
    [MENU_ITEM.CPI]: 'cost',
    [MENU_ITEM.HS_CODE]: 'harmonized_system_code',
    [MENU_ITEM.PHOTOS]: 'photos',
    [MENU_ITEM.PRICE]: 'price',
    [MENU_ITEM.PRODUCT_TYPE]: 'product_type',
    [MENU_ITEM.QUANTITY]: 'quantity',
    [MENU_ITEM.SKU]: 'sku',
    [MENU_ITEM.TAGS]: 'tags',
    [MENU_ITEM.TITLE]: 'title',
    [MENU_ITEM.VARIATIONS]: 'variations',
    [MENU_ITEM.VENDOR]: 'vendor',
    [MENU_ITEM.WEIGHT]: 'weight',
  },
};

export const MENU_ITEMS_WITH_AI = {
  [EBAY]: {
    [MENU_ITEM.DESCRIPTION]: true,
    [MENU_ITEM.PHOTOS]: true,
    [MENU_ITEM.TITLE]: true,
  },
  [ETSY]: {
    [MENU_ITEM.DESCRIPTION]: true,
    [MENU_ITEM.PHOTOS]: true,
    [MENU_ITEM.TAGS]: true,
    [MENU_ITEM.TITLE]: true,
  },
  [FAIRE]: {
    [MENU_ITEM.DESCRIPTION]: true,
    [MENU_ITEM.PHOTOS]: true,
    [MENU_ITEM.TITLE]: true,
  },
  [SHOPIFY]: {
    [MENU_ITEM.DESCRIPTION]: true,
    [MENU_ITEM.PHOTOS]: true,
    [MENU_ITEM.TAGS]: true,
    [MENU_ITEM.TITLE]: true,
  },
};

export const SAVE_TYPE = {
  SAVE: 'save',
  SYNC: 'sync',
};

export const PRICE_TYPE = {
  ABSOLUTE: 'absolute',
  PERCENTAGE: 'percentage',
};

export const PRICE_TYPES = [
  PRICE_TYPE.ABSOLUTE,
  PRICE_TYPE.PERCENTAGE,
];

export const INTERNATIONAL_PRICE_ITEM = {
  RETAIL_AUD: 'Retail (AUD)',
  RETAIL_CAD: 'Retail (CAD)',
  RETAIL_EUR: 'Retail (EUR)',
  RETAIL_GBP: 'Retail (GBP)',
  RETAIL_USD: 'Retail (USD)',
  WHOLESALE_AUD: 'Wholesale (AUD)',
  WHOLESALE_CAD: 'Wholesale (CAD)',
  WHOLESALE_EUR: 'Wholesale (EUR)',
  WHOLESALE_GBP: 'Wholesale (GBP)',
  WHOLESALE_USD: 'Wholesale (USD)',
};

export const INTERNATIONAL_PRICE_ITEM_TO_ATTRIBUTE_CURRENCY_MAP = {
  [INTERNATIONAL_PRICE_ITEM.RETAIL_AUD]: { attribute: ATTRIBUTE.RETAIL_PRICE, currency: CURRENCY.AUD },
  [INTERNATIONAL_PRICE_ITEM.RETAIL_CAD]: { attribute: ATTRIBUTE.RETAIL_PRICE, currency: CURRENCY.CAD },
  [INTERNATIONAL_PRICE_ITEM.RETAIL_EUR]: { attribute: ATTRIBUTE.RETAIL_PRICE, currency: CURRENCY.EUR },
  [INTERNATIONAL_PRICE_ITEM.RETAIL_GBP]: { attribute: ATTRIBUTE.RETAIL_PRICE, currency: CURRENCY.GBP },
  [INTERNATIONAL_PRICE_ITEM.RETAIL_USD]: { attribute: ATTRIBUTE.RETAIL_PRICE, currency: CURRENCY.USD },
  [INTERNATIONAL_PRICE_ITEM.WHOLESALE_AUD]: { attribute: ATTRIBUTE.WHOLESALE_PRICE, currency: CURRENCY.AUD },
  [INTERNATIONAL_PRICE_ITEM.WHOLESALE_CAD]: { attribute: ATTRIBUTE.WHOLESALE_PRICE, currency: CURRENCY.CAD },
  [INTERNATIONAL_PRICE_ITEM.WHOLESALE_EUR]: { attribute: ATTRIBUTE.WHOLESALE_PRICE, currency: CURRENCY.EUR },
  [INTERNATIONAL_PRICE_ITEM.WHOLESALE_GBP]: { attribute: ATTRIBUTE.WHOLESALE_PRICE, currency: CURRENCY.GBP },
  [INTERNATIONAL_PRICE_ITEM.WHOLESALE_USD]: { attribute: ATTRIBUTE.WHOLESALE_PRICE, currency: CURRENCY.USD },
};

export const PRICE_ATTRIBUTE_CURRENCY_TO_INTERNATIONAL_PRICE_ITEM_MAP = {
  [ATTRIBUTE.RETAIL_PRICE]: {
    [CURRENCY.AUD]: INTERNATIONAL_PRICE_ITEM.RETAIL_AUD,
    [CURRENCY.CAD]: INTERNATIONAL_PRICE_ITEM.RETAIL_CAD,
    [CURRENCY.EUR]: INTERNATIONAL_PRICE_ITEM.RETAIL_EUR,
    [CURRENCY.GBP]: INTERNATIONAL_PRICE_ITEM.RETAIL_GBP,
    [CURRENCY.USD]: INTERNATIONAL_PRICE_ITEM.RETAIL_USD,
  },
  [ATTRIBUTE.WHOLESALE_PRICE]: {
    [CURRENCY.AUD]: INTERNATIONAL_PRICE_ITEM.WHOLESALE_AUD,
    [CURRENCY.CAD]: INTERNATIONAL_PRICE_ITEM.WHOLESALE_CAD,
    [CURRENCY.EUR]: INTERNATIONAL_PRICE_ITEM.WHOLESALE_EUR,
    [CURRENCY.GBP]: INTERNATIONAL_PRICE_ITEM.WHOLESALE_GBP,
    [CURRENCY.USD]: INTERNATIONAL_PRICE_ITEM.WHOLESALE_USD,
  },
};

export const INTERNATIONAL_PRICE_ITEMS = [
  INTERNATIONAL_PRICE_ITEM.WHOLESALE_USD,
  INTERNATIONAL_PRICE_ITEM.RETAIL_USD,
  INTERNATIONAL_PRICE_ITEM.WHOLESALE_CAD,
  INTERNATIONAL_PRICE_ITEM.RETAIL_CAD,
  INTERNATIONAL_PRICE_ITEM.WHOLESALE_GBP,
  INTERNATIONAL_PRICE_ITEM.RETAIL_GBP,
  INTERNATIONAL_PRICE_ITEM.WHOLESALE_AUD,
  INTERNATIONAL_PRICE_ITEM.RETAIL_AUD,
  INTERNATIONAL_PRICE_ITEM.WHOLESALE_EUR,
  INTERNATIONAL_PRICE_ITEM.RETAIL_EUR,
];

export const INVENTORY_OPERATIONS = {
  [EBAY]: {
    [ATTRIBUTE.PRICE]: OPERATIONS[EBAY].PRICE.CHANGE_TO,
    [ATTRIBUTE.QUANTITY]: OPERATIONS[EBAY].QUANTITY.CHANGE_TO,
    [ATTRIBUTE.SKU]: OPERATIONS[EBAY].SKU.CHANGE_TO,
    [ATTRIBUTE.VARIATIONS]: OPERATIONS[EBAY].VARIATIONS,
  },
  [ETSY]: {
    [ATTRIBUTE.PRICE]: OPERATIONS[ETSY].PRICE.CHANGE_TO,
    [ATTRIBUTE.QUANTITY]: OPERATIONS[ETSY].QUANTITY.CHANGE_TO,
    [ATTRIBUTE.SKU]: OPERATIONS[ETSY].SKU.CHANGE_TO,
  },
  [FAIRE]: {
    [ATTRIBUTE.CONTINUE_SELLING]: OPERATIONS[FAIRE].CONTINUE_SELLING.SET,
    [ATTRIBUTE.DEADLINE_DATE]: OPERATIONS[FAIRE].DEADLINE_DATE.SET,
    [ATTRIBUTE.DISTANCE_UNIT]: OPERATIONS[FAIRE].DISTANCE_UNIT,
    [ATTRIBUTE.END_DATE]: OPERATIONS[FAIRE].END_DATE.SET,
    [ATTRIBUTE.GTIN]: OPERATIONS[FAIRE].GTIN.CHANGE_TO,
    [ATTRIBUTE.HEIGHT]: OPERATIONS[FAIRE].HEIGHT.SET,
    [ATTRIBUTE.KEEP_ACTIVE]: OPERATIONS[FAIRE].KEEP_ACTIVE.SET,
    [ATTRIBUTE.LENGTH]: OPERATIONS[FAIRE].LENGTH.SET,
    [ATTRIBUTE.MASS_UNIT]: OPERATIONS[FAIRE].MASS_UNIT,
    [ATTRIBUTE.PREORDER]: OPERATIONS[FAIRE].PREORDER.SET,
    [ATTRIBUTE.RETAIL_PRICE]: OPERATIONS[FAIRE].PRICES.SET,
    [ATTRIBUTE.QUANTITY]: OPERATIONS[FAIRE].QUANTITY.CHANGE_TO,
    [ATTRIBUTE.RESTOCK_DATE]: OPERATIONS[FAIRE].RESTOCK_DATE.SET,
    [ATTRIBUTE.SKU]: OPERATIONS[FAIRE].SKU.CHANGE_TO,
    [ATTRIBUTE.START_DATE]: OPERATIONS[FAIRE].START_DATE.SET,
    [ATTRIBUTE.TARIFF_CODE]: OPERATIONS[FAIRE].TARIFF_CODE.SET,
    [ATTRIBUTE.VARIATIONS]: OPERATIONS[FAIRE].VARIATIONS,
    [ATTRIBUTE.WHOLESALE_PRICE]: OPERATIONS[FAIRE].PRICES.SET,
    [ATTRIBUTE.WEIGHT]: OPERATIONS[FAIRE].WEIGHT.SET,
    [ATTRIBUTE.WIDTH]: OPERATIONS[FAIRE].WIDTH.SET,
  },
  [SHOPIFY]: {
    [ATTRIBUTE.BARCODE]: OPERATIONS[SHOPIFY].BARCODE.INLINE_EDIT,
    [ATTRIBUTE.CAP]: OPERATIONS[SHOPIFY].CAP.INLINE_EDIT,
    [ATTRIBUTE.CPI]: OPERATIONS[SHOPIFY].CPI.INLINE_EDIT,
    [ATTRIBUTE.CHARGE_TAX]: OPERATIONS[SHOPIFY].CHARGE_TAX.INLINE_EDIT,
    [ATTRIBUTE.CONTINUE_SELLING]: OPERATIONS[SHOPIFY].CONTINUE_SELLING.INLINE_EDIT,
    [ATTRIBUTE.COUNTRY_CODE]: OPERATIONS[SHOPIFY].COUNTRY_CODE.INLINE_EDIT,
    [ATTRIBUTE.HS_CODE]: OPERATIONS[SHOPIFY].HS_CODE.INLINE_EDIT,
    [ATTRIBUTE.PHYSICAL]: OPERATIONS[SHOPIFY].PHYSICAL.INLINE_EDIT,
    [ATTRIBUTE.PRICE]: OPERATIONS[SHOPIFY].PRICE.INLINE_EDIT,
    [ATTRIBUTE.QUANTITY]: OPERATIONS[SHOPIFY].QUANTITY.INLINE_EDIT,
    [ATTRIBUTE.SKU]: OPERATIONS[SHOPIFY].SKU.INLINE_EDIT,
    [ATTRIBUTE.TRACK_QUANTITY]: OPERATIONS[SHOPIFY].QUANTITY.INLINE_EDIT,
    [ATTRIBUTE.UNIT]: OPERATIONS[SHOPIFY].WEIGHT.INLINE_EDIT,
    [ATTRIBUTE.WEIGHT]: OPERATIONS[SHOPIFY].WEIGHT.INLINE_EDIT,
    [ATTRIBUTE.SHIPPING]: OPERATIONS[SHOPIFY].WEIGHT.INLINE_EDIT,
  },
};

export const SIZE_OPERATIONS = {
  [EBAY]: {
    [OPERATIONS[EBAY].SIZE.SET]: {
      [ATTRIBUTE.DEPTH]: OPERATIONS[EBAY].DEPTH.SET,
      [ATTRIBUTE.LENGTH]: OPERATIONS[EBAY].LENGTH.SET,
      [ATTRIBUTE.WIDTH]: OPERATIONS[EBAY].WIDTH.SET,
    },
    [OPERATIONS[EBAY].SIZE.INCREASE_BY]: {
      [ATTRIBUTE.DEPTH]: OPERATIONS[EBAY].DEPTH.INCREASE_BY,
      [ATTRIBUTE.LENGTH]: OPERATIONS[EBAY].LENGTH.INCREASE_BY,
      [ATTRIBUTE.WIDTH]: OPERATIONS[EBAY].WIDTH.INCREASE_BY,
    },
    [OPERATIONS[EBAY].SIZE.DECREASE_BY]: {
      [ATTRIBUTE.DEPTH]: OPERATIONS[EBAY].DEPTH.DECREASE_BY,
      [ATTRIBUTE.LENGTH]: OPERATIONS[EBAY].LENGTH.DECREASE_BY,
      [ATTRIBUTE.WIDTH]: OPERATIONS[EBAY].WIDTH.DECREASE_BY,
    },
  },
  [ETSY]: {
    [OPERATIONS[ETSY].SIZE.SET]: {
      [ATTRIBUTE.HEIGHT]: OPERATIONS[ETSY].HEIGHT.SET,
      [ATTRIBUTE.LENGTH]: OPERATIONS[ETSY].LENGTH.SET,
      [ATTRIBUTE.WIDTH]: OPERATIONS[ETSY].WIDTH.SET,
    },
    [OPERATIONS[ETSY].SIZE.INCREASE_BY]: {
      [ATTRIBUTE.HEIGHT]: OPERATIONS[ETSY].HEIGHT.INCREASE_BY,
      [ATTRIBUTE.LENGTH]: OPERATIONS[ETSY].LENGTH.INCREASE_BY,
      [ATTRIBUTE.WIDTH]: OPERATIONS[ETSY].WIDTH.INCREASE_BY,
    },
    [OPERATIONS[ETSY].SIZE.DECREASE_BY]: {
      [ATTRIBUTE.HEIGHT]: OPERATIONS[ETSY].HEIGHT.DECREASE_BY,
      [ATTRIBUTE.LENGTH]: OPERATIONS[ETSY].LENGTH.DECREASE_BY,
      [ATTRIBUTE.WIDTH]: OPERATIONS[ETSY].WIDTH.DECREASE_BY,
    },
  },
  [FAIRE]: {
    [OPERATIONS[FAIRE].SIZE.SET]: {
      [ATTRIBUTE.HEIGHT]: OPERATIONS[FAIRE].HEIGHT.SET,
      [ATTRIBUTE.LENGTH]: OPERATIONS[FAIRE].LENGTH.SET,
      [ATTRIBUTE.WIDTH]: OPERATIONS[FAIRE].WIDTH.SET,
    },
    [OPERATIONS[FAIRE].SIZE.INCREASE_BY]: {
      [ATTRIBUTE.HEIGHT]: OPERATIONS[FAIRE].HEIGHT.INCREASE_BY,
      [ATTRIBUTE.LENGTH]: OPERATIONS[FAIRE].LENGTH.INCREASE_BY,
      [ATTRIBUTE.WIDTH]: OPERATIONS[FAIRE].WIDTH.INCREASE_BY,
    },
    [OPERATIONS[FAIRE].SIZE.DECREASE_BY]: {
      [ATTRIBUTE.HEIGHT]: OPERATIONS[FAIRE].HEIGHT.DECREASE_BY,
      [ATTRIBUTE.LENGTH]: OPERATIONS[FAIRE].LENGTH.DECREASE_BY,
      [ATTRIBUTE.WIDTH]: OPERATIONS[FAIRE].WIDTH.DECREASE_BY,
    },
  },
};

export const WEIGHT_OPERATIONS = {
  [OPERATIONS[EBAY].WEIGHT.SET]: {
    [ATTRIBUTE.WEIGHT_MAJOR]: OPERATIONS[EBAY].WEIGHT_MAJOR.SET,
    [ATTRIBUTE.WEIGHT_MINOR]: OPERATIONS[EBAY].WEIGHT_MINOR.SET,
  },
  [OPERATIONS[EBAY].WEIGHT.INCREASE_BY]: {
    [ATTRIBUTE.WEIGHT_MAJOR]: OPERATIONS[EBAY].WEIGHT_MAJOR.INCREASE_BY,
    [ATTRIBUTE.WEIGHT_MINOR]: OPERATIONS[EBAY].WEIGHT_MINOR.INCREASE_BY,
  },
  [OPERATIONS[EBAY].WEIGHT.DECREASE_BY]: {
    [ATTRIBUTE.WEIGHT_MAJOR]: OPERATIONS[EBAY].WEIGHT_MAJOR.DECREASE_BY,
    [ATTRIBUTE.WEIGHT_MINOR]: OPERATIONS[EBAY].WEIGHT_MINOR.DECREASE_BY,
  },
};

export const LOCATION_OPERATIONS = {
  [EBAY]: {
    [ATTRIBUTE.COUNTRY]: OPERATIONS[EBAY].COUNTRY,
    [ATTRIBUTE.LOCATION]: OPERATIONS[EBAY].LOCATION,
    [ATTRIBUTE.POSTAL_CODE]: OPERATIONS[EBAY].POSTAL_CODE,
  },
};

export const BANNER = {
  AI_GENERATED: 'ai-generated',
};

export const ETSY_TITLE_STRATEGIES = {
  CLASSIC: 'classic',
  CONCISE: 'concise',
};

export const ETSY_AI_CHANNELS = {
  [ETSY_TITLE_STRATEGIES.CLASSIC]: 'etsy-classic',
  [ETSY_TITLE_STRATEGIES.CONCISE]: 'etsy-concise',
};
